/* ── État animations : on respecte la préférence système ── */
const reduceOS = !window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
const animOK = () => !reduceOS;

/* ── Reveal stagger + titres mot à mot ── */
function decoupeEnMots(h) {
  const morceaux = [];
  h.childNodes.forEach((n) => {
    if (n.nodeType === Node.TEXT_NODE) {
      n.textContent.split(/(\s+)/).forEach((m) => {
        if (/^\s+$/.test(m)) { morceaux.push(document.createTextNode(' ')); }
        else if (m) { const s = document.createElement('span'); s.className = 'm'; s.textContent = m; morceaux.push(s); }
      });
    } else {
      const s = document.createElement('span'); s.className = 'm'; s.appendChild(n.cloneNode(true)); morceaux.push(s);
    }
  });
  h.setAttribute('aria-label', h.textContent.trim());
  h.textContent = '';
  let i = 0;
  morceaux.forEach((m) => { if (m.nodeType === 1) { m.setAttribute('aria-hidden', 'true'); m.style.setProperty('--i', i++); } h.appendChild(m); });
  h.classList.add('mot');
}
if (!reduceOS) {
  document.querySelectorAll('section h2:not(.sans-mots), .nuit h2:not(.sans-mots)').forEach(decoupeEnMots);
}
/* Le héros vient d'encrer : surlignage des mots forts du sous-titre + balayage
   slush sous « minuit » (déclenchés une fois les mots posés) */
requestAnimationFrame(() => setTimeout(() => document.querySelector('.hero')?.classList.add('encre'), reduceOS ? 0 : 450));
/* Souligné slush des accents CatchLAND : dessiné à l'entrée à l'écran, persistant */
if ('IntersectionObserver' in window) {
  const ioAccents = new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('ok'); ioAccents.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' });
  document.querySelectorAll('.accent-catch').forEach((a) => ioAccents.observe(a));
} else {
  document.querySelectorAll('.accent-catch').forEach((a) => a.classList.add('ok'));
}
if (!reduceOS && 'IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target;
      el.classList.add('vu');
      io.unobserve(el);
      /* L'entrée jouée, on rend à l'élément ses transitions d'interaction
         (sinon le tilt/hover hérite des 480 ms + délai du reveal) */
      if (el.classList.contains('reveal')) {
        const delai = parseInt(getComputedStyle(el).transitionDelay) || 0;
        setTimeout(() => el.classList.remove('reveal', 'vu'), 560 + delai);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal, .mot').forEach((el) => io.observe(el));
} else {
  document.querySelectorAll('.reveal, .mot').forEach((el) => el.classList.add('vu'));
}

/* ── Ombre header au scroll ── */
const header = document.getElementById('header');
if (header) {
  const logoH = header.querySelector('.logo');
  function mesureLogo() {
    if (!logoH) return;
    const hr = header.getBoundingClientRect();
    const lr = logoH.getBoundingClientRect();
    const decale = getComputedStyle(logoH).transform;
    /* distance du centre du logo (hors transform) au centre du header */
    const centreLogo = lr.left + lr.width / 2 - (decale !== 'none' ? new DOMMatrix(decale).m41 : 0);
    logoH.style.setProperty('--dx-logo', (hr.left + hr.width / 2 - centreLogo).toFixed(1) + 'px');
  }
  mesureLogo();
  window.addEventListener('resize', mesureLogo, { passive: true });
  window.addEventListener('scroll', () => header.classList.toggle('ombre', window.scrollY > 20), { passive: true });
}

/* ── Menu mobile : burger + panneau ── */
const burger = document.getElementById('burger');
const panneau = document.getElementById('panneau-nav');
if (burger && panneau) {
  const bascule = (ouvre) => {
    burger.setAttribute('aria-expanded', String(ouvre));
    panneau.classList.toggle('ouvert', ouvre);
    document.documentElement.style.overflow = ouvre ? 'hidden' : '';
  };
  burger.addEventListener('click', () => bascule(!panneau.classList.contains('ouvert')));
  panneau.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => bascule(false)));
  const fermer = document.getElementById('fermer-nav');
  if (fermer) fermer.addEventListener('click', () => bascule(false));
}

/* ── Compteurs animés du héros ── */
function lanceCompteur(el) {
  const cible = parseInt(el.dataset.count, 10);
  const prefix = el.dataset.prefix || '';
  const suffix = el.dataset.suffix || '';
  if (!animOK()) { el.textContent = prefix + cible + suffix; return; }
  const t0 = performance.now(); const dur = 1100;
  const tick = (t) => {
    const p = Math.min(1, (t - t0) / dur);
    const eased = 1 - Math.pow(1 - p, 3);
    el.textContent = prefix + Math.round(cible * eased) + suffix;
    el.style.transform = `scale(${(0.9 + 0.1 * eased).toFixed(3)})`;
    if (p < 1) requestAnimationFrame(tick);
    else {
      el.animate([
        { transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }
      ], { duration: 340, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' });
    }
  };
  el.style.display = 'inline-block'; el.style.transformOrigin = 'left center';
  requestAnimationFrame(tick);
}
if ('IntersectionObserver' in window) {
  const ioCount = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { ioCount.unobserve(e.target); lanceCompteur(e.target); } });
  }, { threshold: 0.35 });
  document.querySelectorAll('[data-count]').forEach((el) => ioCount.observe(el));
} else {
  document.querySelectorAll('[data-count]').forEach(lanceCompteur);
}

/* ── Tilt 3D sur les cartes produit (souris uniquement) ── */
if (window.matchMedia('(hover: hover)').matches) {
  document.querySelectorAll('.tilt').forEach((carte) => {
    carte.addEventListener('pointermove', (ev) => {
      if (!animOK()) return;
      const r = carte.getBoundingClientRect();
      const x = (ev.clientX - r.left) / r.width - 0.5;
      const y = (ev.clientY - r.top) / r.height - 0.5;
      carte.style.transform = `perspective(700px) rotateY(${x * 7}deg) rotateX(${y * -7}deg) translateY(-4px)`;
    });
    carte.addEventListener('pointerleave', () => { carte.style.transform = ''; });
  });
}

/* ── CTA magnétique (subtil) ── */
const cta = document.getElementById('cta-magnetique');
if (cta && window.matchMedia('(hover: hover)').matches) {
  cta.addEventListener('pointermove', (ev) => {
    if (!animOK()) return;
    const r = cta.getBoundingClientRect();
    const x = (ev.clientX - r.left) / r.width - 0.5;
    const y = (ev.clientY - r.top) / r.height - 0.5;
    cta.style.transform = `translate(${x * 6}px, ${y * 5}px)`;
  });
  cta.addEventListener('pointerleave', () => { cta.style.transform = ''; });
}

/* ── Étoiles (déterministe) : ciel global + footer ── */
function semeEtoiles(conteneur, n, graine) {
  if (!conteneur) return;
  const alea = () => { graine = (graine * 9301 + 49297) % 233280; return graine / 233280; };
  for (let i = 0; i < n; i++) {
    const e = document.createElement('i');
    e.style.left = (alea() * 98) + '%';
    e.style.top = (alea() * 92) + '%';
    e.style.animationDelay = (-alea() * 4).toFixed(2) + 's';
    conteneur.appendChild(e);
  }
}
semeEtoiles(document.getElementById('astres'), 64, 42);
semeEtoiles(document.getElementById('etoiles-footer'), 22, 7);

/* ══════════════════════════════════════════════════════════════
   LE CIEL CONTINU — la couleur de fond est interpolée au scroll
   entre des ancres posées sur les sections. La « nuit » (étoiles,
   lune) et le « jour » (nuages) suivent la luminosité du ciel.
   ══════════════════════════════════════════════════════════════ */
const ciel = document.getElementById('ciel');
const racine = document.documentElement;
const hex = (c) => [parseInt(c.slice(1, 3), 16), parseInt(c.slice(3, 5), 16), parseInt(c.slice(5, 7), 16)];
/* [sélecteur d'ancre, couleur du ciel quand cette ancre est au centre de l'écran] */
const ANCRES_DEF = [
  ['.hero',        '#fff5fc'],  /* midi : crème */
  ['#nouveautes',  '#fff3fa'],
  ['#univers',     '#fbdff4'],  /* l'après-midi rosit */
  ['#marquee',     '#f4cdea'],  /* l'après-midi s'intensifie */
  ['#packs',       '#7a3f70'],  /* crépuscule — la vraie nuit vit DANS le panneau */
  ['#livraison',   '#f6d9ee'],  /* l'aube rosée */
  ['.avis',        '#fff5fc'],
  ['.boutique',    '#fff5fc'],
  ['.news',        '#1b1526'],  /* la newsletter vit dans la vraie nuit du ciel */
  ['.rideau-footer', '#141414']
];
let ancres = [];
function mesureAncres() {
  ancres = ANCRES_DEF.map(([sel, coul]) => {
    const el = document.querySelector(sel);
    return el ? { y: el.offsetTop + el.offsetHeight * 0.5, rgb: hex(coul) } : null;
  }).filter(Boolean).sort((a, b) => a.y - b.y);
  /* Page interne (produit, collection…) : pas assez d'ancres pour raconter la
     journée → ciel crème stable, jamais de texte noir sur fond sombre */
  if (ancres.length < 3) {
    ancres = [{ y: 0, rgb: hex('#fff5fc') }];
  }
}
let cielActuel = hex('#fff5fc');
function couleurCible() {
  const c = window.scrollY + window.innerHeight * 0.5;
  if (c <= ancres[0].y) return ancres[0].rgb;
  for (let i = 0; i < ancres.length - 1; i++) {
    const a = ancres[i], b = ancres[i + 1];
    if (c >= a.y && c <= b.y) {
      const t = (c - a.y) / (b.y - a.y);
      const e = t * t * (3 - 2 * t); /* smoothstep */
      return a.rgb.map((v, k) => v + (b.rgb[k] - v) * e);
    }
  }
  return ancres[ancres.length - 1].rgb;
}
function majCiel(instant) {
  /* Sans le ciel (réglage décochable), on sort : sinon une erreur ici
     interromprait tout le script — panier, age-gate, cookies compris. */
  if (!ciel || !ancres.length) return;
  const cible = couleurCible();
  const k = (instant || !animOK()) ? 1 : 0.16;
  cielActuel = cielActuel.map((v, i) => v + (cible[i] - v) * k);
  const [r, g, b] = cielActuel.map(Math.round);
  ciel.style.backgroundColor = `rgb(${r},${g},${b})`;
  const lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  const nuitO = Math.min(1, Math.max(0, (0.62 - lum) * 2.4));
  racine.style.setProperty('--nuit-o', nuitO.toFixed(3));
  racine.style.setProperty('--jour-o', (1 - nuitO).toFixed(3));
  ciel.classList.toggle('sans-nuit', nuitO < 0.02);
  ciel.classList.toggle('sans-jour', nuitO > 0.98);
}
/* Marquee : en pause hors écran (absent des pages internes) */
if ('IntersectionObserver' in window) {
  const m = document.getElementById('marquee');
  if (m) new IntersectionObserver((es) => es.forEach((e) => m.classList.toggle('hors', !e.isIntersecting))).observe(m);
}

/* ── Parallaxe des nuages (scroll + souris) ── */
const nuages = [...document.querySelectorAll('.nuage')];
let sourisX = 0, sourisY = 0;
if (window.matchMedia('(hover: hover)').matches) {
  window.addEventListener('pointermove', (e) => {
    sourisX = e.clientX / window.innerWidth - 0.5;
    sourisY = e.clientY / window.innerHeight - 0.5;
  }, { passive: true });
}
function majNuages() {
  if (!animOK()) return;
  nuages.forEach((n) => {
    const d = parseFloat(n.dataset.depth || 0.3);
    n.style.setProperty('--py', (-window.scrollY * d * 0.14 + sourisY * d * 26) + 'px');
    n.style.setProperty('--px', (sourisX * d * 34) + 'px');
  });
}

/* ══════════════════════════════════════════════════════════════
   LA CANETTE QUI TOMBE — trajectoire pilotée par le scroll,
   lissée image par image (recette SurSur / Apple).
   Points de passage : apparaît aux univers, traverse le crépuscule,
   tournoie dans la nuit, sort à l'aube.
   ══════════════════════════════════════════════════════════════ */
const pluie = [...document.querySelectorAll('.chute-item')].map((el) => ({ el, etapes: [], pose: null }));
function mesureChute() {
  const vh = window.innerHeight;
  const nouveautes = document.getElementById('nouveautes');
  const univers = document.getElementById('univers');
  const marquee = document.getElementById('marquee');
  const packs = document.getElementById('packs');
  const livraison = document.getElementById('livraison');
  if (!nouveautes || !univers || !marquee || !packs || !livraison) { pluie.forEach((it) => { it.etapes = []; }); return; }
  /* Chaque produit a SON parcours : côté d'entrée, fenêtre de scroll et
     rotation propres. Courts et espacés — et tous terminés AVANT la section
     livraison pour ne jamais gêner la carte.
     [y doc de déclenchement, [x vw, y vh, rotation °, échelle, opacité]] */
  const trajets = [
    /* Fanta Raisin Japon : bord droit, pendant les nouveautés */
    [[nouveautes.offsetTop - vh * 0.8, [85, -18, -20, 0.9, 0]],
     [nouveautes.offsetTop - vh * 0.2, [89,  22,  10, 1,   1]],
     [univers.offsetTop - vh * 0.55,   [82,  68,  55, 1.05, 1]],
     [univers.offsetTop - vh * 0.05,   [78, 118, 100, 1,   0]]],
    /* Takis Mexique : bord GAUCHE, pendant les univers */
    [[univers.offsetTop - vh * 0.75,   [7,  -16,  25, 0.95, 0]],
     [univers.offsetTop - vh * 0.15,   [3,   28, -15, 1.05, 1]],
     [marquee.offsetTop - vh * 0.5,    [9,   72, -65, 1.1,  1]],
     [marquee.offsetTop + vh * 0.05,   [13, 122, -95, 1,    0]]],
    /* Buldak Corée : traverse du centre vers la droite, au crépuscule */
    [[marquee.offsetTop - vh * 0.65,   [58, -16,  10, 0.9,  0]],
     [marquee.offsetTop - vh * 0.05,   [52,  34,  60, 1,    1]],
     [packs.offsetTop + vh * 0.25,     [86,  60, 125, 1.06, 1]],
     [packs.offsetTop + vh * 0.75,     [89, 118, 165, 1,    0]]],
    /* Pocky Japon : bord gauche, dans la nuit */
    [[packs.offsetTop - vh * 0.35,     [6,  -15, -15, 0.95, 0]],
     [packs.offsetTop + vh * 0.15,     [10,  26,  25, 1.05, 1]],
     [packs.offsetTop + vh * 0.65,     [4,   68,  75, 1.1,  1]],
     [packs.offsetTop + vh * 0.95,     [8,  120, 115, 1,    0]]],
    /* Fanta Pastèque Chine : bord droit, fin de nuit — sortie AVANT la carte */
    [[packs.offsetTop + vh * 0.45,     [90, -14,  30, 0.9,  0]],
     [packs.offsetTop + vh * 0.95,     [86,  32,  90, 1.05, 1]],
     [livraison.offsetTop - vh * 1.05, [92,  70, 145, 1,    1]],
     [livraison.offsetTop - vh * 0.65, [95, 122, 185, 0.9,  0]]],
    /* Slot 6 : centre-gauche, tôt (nouveautés → univers) */
    [[nouveautes.offsetTop - vh * 0.5, [28, -16,  -30, 0.85, 0]],
     [nouveautes.offsetTop + vh * 0.1, [24,  30,   15, 0.95, 1]],
     [univers.offsetTop - vh * 0.35,   [30,  74,   60, 1,    1]],
     [univers.offsetTop + vh * 0.1,    [26, 120,  100, 0.95, 0]]],
    /* Slot 7 : droite, crépuscule (univers → marquee) */
    [[univers.offsetTop - vh * 0.4,    [72, -15,   20, 0.9,  0]],
     [univers.offsetTop + vh * 0.2,    [76,  26,  -25, 1,    1]],
     [marquee.offsetTop - vh * 0.3,    [70,  70,  -70, 1.05, 1]],
     [marquee.offsetTop + vh * 0.2,    [74, 120, -110, 0.95, 0]]],
    /* Slot 8 : gauche, pleine nuit (packs) */
    [[packs.offsetTop - vh * 0.15,     [16, -16,   35, 0.9,  0]],
     [packs.offsetTop + vh * 0.35,     [12,  30,   80, 1,    1]],
     [packs.offsetTop + vh * 0.85,     [18,  72,  130, 1.05, 1]],
     [livraison.offsetTop - vh * 0.75, [14, 120,  170, 0.95, 0]]]
  ];
  /* Sécurité : chaque trajectoire doit être strictement croissante et
     entièrement terminée avant la carte de livraison — quel que soit
     l'espacement réel des sections dans le thème (fix « pastèque bloquée ») */
  const finPluie = livraison.offsetTop - vh * 0.55;
  pluie.forEach((it, i) => {
    let tr = (trajets[i] || []).slice();
    tr.forEach((et) => { if (et[0] > finPluie) et[0] = finPluie; });
    for (let k = 1; k < tr.length; k++) {
      if (tr[k][0] <= tr[k - 1][0]) tr[k][0] = tr[k - 1][0] + Math.max(60, vh * 0.12);
    }
    const dernier = tr[tr.length - 1];
    if (dernier) dernier[1][4] = 0; /* on sort toujours invisible */
    it.etapes = tr;
  });
}
function poseCible(etapes, yScroll) {
  if (yScroll <= etapes[0][0]) return etapes[0][1];
  for (let i = 0; i < etapes.length - 1; i++) {
    const [y0, p0] = etapes[i], [y1, p1] = etapes[i + 1];
    if (yScroll >= y0 && yScroll <= y1) {
      const t = (yScroll - y0) / (y1 - y0);
      const e = t * t * (3 - 2 * t);
      return p0.map((v, k) => v + (p1[k] - v) * e);
    }
  }
  return etapes[etapes.length - 1][1];
}
/* v40 : inertie indépendante du framerate, balancement organique et rotation
   liée à la vitesse de scroll — la chute devient physique, plus jamais mécanique. */
let chuteT = 0, chuteDT = 16.7, scrollPrec = window.scrollY, velScroll = 0;
function majChute(instant) {
  if (!animOK()) return;
  const k = instant ? 1 : 1 - Math.pow(0.885, chuteDT / 16.7);
  velScroll += ((window.scrollY - scrollPrec) - velScroll) * 0.12;
  scrollPrec = window.scrollY;
  pluie.forEach((it, i) => {
    if (!it.etapes.length) return;
    const cible = poseCible(it.etapes, window.scrollY);
    if (!it.pose || instant) it.pose = cible.slice();
    else it.pose = it.pose.map((v, j) => v + (cible[j] - v) * k);
    const [x, y, rot, ech, o] = it.pose;
    /* Balancement : s'estompe quand tout est posé pour laisser dormir la boucle */
    const amp = Math.min(1, Math.abs(velScroll) * 0.04 + 0.25);
    const sway = Math.sin(chuteT * 0.0011 + i * 1.7) * 0.6 * amp;
    const rotV = Math.max(-14, Math.min(14, velScroll * 0.06));
    const rotSway = Math.sin(chuteT * 0.0009 + i * 2.3) * 2.2 * amp;
    it.el.style.transform = `translate(${x + sway}vw, ${y}vh) rotate(${rot + rotV + rotSway}deg) scale(${ech})`;
    it.el.style.opacity = o.toFixed(3);
  });
}

/* ── Boucle d'animation du ciel (légère : 3 setProperty par frame) ── */
mesureAncres(); mesureChute(); majCiel(true); majChute(true); majNuages();
let enCours = false;
let boucleTPrec = performance.now();
function boucle(t) {
  if (typeof t === 'number') { chuteDT = Math.min(50, Math.max(4, t - boucleTPrec)); boucleTPrec = t; chuteT = t; }
  majCiel(false); majChute(false); majNuages();
  const [r, g, b] = cielActuel;
  const cible = couleurCible();
  let delta = Math.abs(cible[0] - r) + Math.abs(cible[1] - g) + Math.abs(cible[2] - b);
  pluie.forEach((it) => {
    if (!it.pose || !it.etapes.length) return;
    const pc = poseCible(it.etapes, window.scrollY);
    delta += pc.reduce((sm, v, i) => sm + Math.abs(v - it.pose[i]), 0);
  });
  if (delta > 0.8 || document.hasFocus()) { requestAnimationFrame(boucle); }
  else { enCours = false; }
}
let dernierVH = window.innerHeight;
function reveille() {
  /* Onglet chargé en arrière-plan (viewport 0) puis affiché : on re-mesure */
  if (window.innerHeight !== dernierVH) { dernierVH = window.innerHeight; mesureAncres(); mesureChute(); }
  if (!enCours) { enCours = true; requestAnimationFrame(boucle); }
}
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') { mesureAncres(); mesureChute(); reveille(); }
});
window.addEventListener('scroll', reveille, { passive: true });
window.addEventListener('pointermove', reveille, { passive: true });
window.addEventListener('resize', () => { mesureAncres(); mesureChute(); reveille(); }, { passive: true });
window.addEventListener('load', () => { mesureAncres(); mesureChute(); majCiel(true); });
reveille();

/* ── Fly-to-cart : le produit s'envole vers le panier ── */
const badgeCount = document.getElementById('panier-count');
let comptePanier = badgeCount ? parseInt(badgeCount.textContent, 10) || 0 : 0;
document.querySelectorAll('.ajout').forEach((btn) => {
  btn.addEventListener('click', () => {
    const variante = btn.dataset.variant;
    if (variante) {
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variante, 10), quantity: 1 }] })
      }).then((r) => r.ok ? fetch('/cart.js').then((c) => c.json()) : Promise.reject())
        .then((cart) => {
        comptePanier = cart.item_count; if (badgeCount) badgeCount.textContent = comptePanier;
        const hote = btn.closest('.carte-produit, .mini-produit, .carte-pack');
        const nom = hote ? (hote.querySelector('.nom, .m-nom, .p-nom') || {}).textContent : '';
        btn.classList.add('ajout-ok');
        setTimeout(() => btn.classList.remove('ajout-ok'), 1400);
        if (document.body.dataset.pays && document.body.dataset.pays !== 'FR') return '';
        const reste = 10000 - cart.total_price;
        const relance = reste > 0 ? 'Encore €' + (reste / 100).toFixed(2).replace('.', ',') + ' → livraison offerte' : 'Livraison France offerte !';
        if (typeof montreToast === 'function') montreToast("C'est dans le sac !", ((nom || '').trim() + ' · ' + relance).replace(/^ · /, ''), 'Voir le panier', '/cart');
      })
        .catch(() => {})
        .finally(() => { btn.disabled = false; });
    } else {
      comptePanier++;
      if (badgeCount) badgeCount.textContent = comptePanier;
    }
    if (badgeCount) { badgeCount.classList.remove('pop'); void badgeCount.offsetWidth; badgeCount.classList.add('pop'); }
    if (!animOK()) return;
    if (typeof popCandy === 'function') popCandy(btn);
    const carteHote = btn.closest('.carte-produit, .mini-produit, .carte-pack');
    const img = carteHote ? carteHote.querySelector('img') : null;
    const cible = document.getElementById('panier');
    if (!img || !cible) return;
    const a = img.getBoundingClientRect(), p = cible.getBoundingClientRect();
    const ghost = img.cloneNode();
    ghost.className = 'vol';
    Object.assign(ghost.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
    document.body.appendChild(ghost);
    const dx = (p.left + p.width / 2) - (a.left + a.width / 2);
    const dy = (p.top + p.height / 2) - (a.top + a.height / 2);
    ghost.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: `translate(${dx * 0.55}px, ${dy - 130}px) scale(0.45) rotate(-14deg)`, opacity: 0.95, offset: 0.6 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.1) rotate(-24deg)`, opacity: 0.25 }
    ], { duration: 680, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }).onfinish = () => ghost.remove();
  });
});

/* ── Bouton Ajouter → « Ajouté ✓ » (morph fondu+blur, interruptible) ── */
document.querySelectorAll('.ajout').forEach((btn) => {
  const texte = [...btn.childNodes].find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
  if (!texte) return;
  const lbl = document.createElement('span');
  lbl.className = 'lbl'; lbl.textContent = texte.textContent.trim();
  texte.replaceWith(lbl);
  let t1, t2;
  btn.addEventListener('click', () => {
    clearTimeout(t1); clearTimeout(t2);
    const pose = (m) => { lbl.classList.add('mue'); setTimeout(() => { lbl.textContent = m; lbl.classList.remove('mue'); }, animOK() ? 180 : 0); };
    pose('Ajouté ✓');
    t1 = setTimeout(() => pose('Ajouter'), 1400);
  });
});

/* ── Newsletter : morph « Bienvenue ! » + burst de particules (delight rare) ── */
const formNews = document.querySelector('.news-form');
if (formNews) {
  formNews.addEventListener('submit', (e) => {
    e.preventDefault();
    const btn = formNews.querySelector('.btn');
    const lbl = btn.querySelector('.lbl');
    if (btn.dataset.ok) return;
    btn.dataset.ok = '1';
    if (formNews.getAttribute('action')) {
      fetch(formNews.getAttribute('action'), { method: 'POST', body: new FormData(formNews) }).catch(() => {});
    }
    lbl.classList.add('mue');
    setTimeout(() => { lbl.textContent = 'Bienvenue !'; lbl.classList.remove('mue'); }, animOK() ? 180 : 0);
    if (typeof popCandy === 'function') setTimeout(() => popCandy(btn), 240);
    if (!animOK()) return;
    const r = btn.getBoundingClientRect();
    const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    const couleurs = ['var(--rose)', 'var(--cyan)', 'var(--magenta)'];
    for (let i = 0; i < 8; i++) {
      const part = document.createElement('i');
      part.className = 'part';
      part.style.left = cx + 'px'; part.style.top = cy + 'px';
      part.style.background = couleurs[i % 3];
      document.body.appendChild(part);
      const a = (i / 8) * Math.PI * 2 + 0.4;
      const d = 44 + (i % 3) * 13;
      part.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: `translate(${Math.cos(a) * d}px, ${Math.sin(a) * d}px) scale(0.4)`, opacity: 0 }
      ], { duration: 600, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }).onfinish = () => part.remove();
    }
  });
}

/* ── Placeholders rotatifs de la recherche ── */
const champRecherche = document.querySelector('.recherche input');
if (champRecherche) {
  const accroches = ['Un soda japonais ? Des chips introuvables ?', 'Un Kit Kat exotique ?', 'Une envie de 23h47 ?'];
  let iA = 0;
  setInterval(() => {
    if (document.activeElement === champRecherche || document.visibilityState !== 'visible') return;
    iA = (iA + 1) % accroches.length;
    if (!animOK()) { champRecherche.placeholder = accroches[iA]; return; }
    champRecherche.classList.add('mue');
    setTimeout(() => { champRecherche.placeholder = accroches[iA]; champRecherche.classList.remove('mue'); }, 250);
  }, 4000);
}

/* ── Annonce alternée ── */
const annonceTxt = document.getElementById('annonce-txt');
if (annonceTxt) {
  const messages = window.MMAnnonces || [
    'Colis suivis en France, en Europe <b>&amp; dans le monde entier</b>',
    'À domicile autour de la boutique <b>jusqu\'à 2h</b> — 4h le week-end'
  ];
  let iM = 0;
  setInterval(() => {
    if (!animOK() || document.visibilityState !== 'visible') return;
    iM = (iM + 1) % messages.length;
    annonceTxt.classList.add('masque');
    setTimeout(() => { annonceTxt.innerHTML = messages[iM]; annonceTxt.classList.remove('masque'); }, 300);
  }, 6500);
}

/* ── Vidéo boutique : ne charge et ne joue qu'à l'approche ── */
const videoBoutique = document.getElementById('video-boutique');
if (videoBoutique && 'IntersectionObserver' in window) {
  const ioVid = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { videoBoutique.play().catch(() => {}); }
      else { videoBoutique.pause(); }
    });
  }, { rootMargin: '200px 0px' });
  ioVid.observe(videoBoutique);
}

/* ── Newsletter : pipeline lumineux (beam → splash → beam), pattern Xero/21st ── */
(function () {
  const pipe = document.getElementById('pipeline-news');
  if (!pipe) return;
  const nSac = document.getElementById('noeud-sac');
  const nEtoile = document.getElementById('noeud-etoile');
  const splash = document.getElementById('splash-news');
  const beamA = document.getElementById('beam-a');
  const beamB = document.getElementById('beam-b');
  const grad = document.getElementById('beam-gradient');
  let sx = 0, ex = 0;
  function traceBeam() {
    const pR = pipe.getBoundingClientRect();
    if (!pR.width) return;
    const centre = (el) => { const r = el.getBoundingClientRect(); return [r.left + r.width / 2 - pR.left, r.top + r.height / 2 - pR.top]; };
    const [ax, ay] = centre(nSac);
    const [mx, my] = centre(document.getElementById('noeud-lune'));
    const [bx, by] = centre(nEtoile);
    const d = `M ${ax},${ay} L ${mx},${my} L ${bx},${by}`;
    beamA.setAttribute('d', d); beamB.setAttribute('d', d);
    sx = ax; ex = bx;
  }
  function poseGrad(f) {
    const c = sx + f * (ex - sx);
    const demi = (ex - sx) * 0.09;
    grad.setAttribute('x1', c - demi); grad.setAttribute('x2', c + demi);
  }
  let etat = 'p1', t0 = 0, enVue = false, tourne = false;
  function pas(now) {
    if (!enVue || !animOK()) { tourne = false; return; }
    const el = now - t0;
    if (etat === 'p1') {
      const pr = Math.min(el / 800, 1);
      poseGrad(pr * 0.5);
      nSac.classList.toggle('actif', pr < 0.4);
      if (pr >= 1) { etat = 'splash'; t0 = now; beamA.style.opacity = '0'; beamB.style.opacity = '0'; splash.classList.add('animate'); }
    } else if (etat === 'splash') {
      if (el >= 800) { etat = 'p2'; t0 = now; splash.classList.remove('animate'); beamA.style.opacity = '0.6'; beamB.style.opacity = '1'; }
    } else if (etat === 'p2') {
      const pr = Math.min(el / 800, 1);
      poseGrad(0.5 + pr * 0.5);
      nEtoile.classList.toggle('actif', pr > 0.6);
      if (pr >= 1) { nEtoile.classList.remove('actif'); etat = 'idle'; t0 = now; }
    } else if (el >= 1000) { etat = 'p1'; t0 = now; }
    requestAnimationFrame(pas);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((es) => {
      es.forEach((e) => {
        enVue = e.isIntersecting;
        if (enVue && !tourne && animOK()) {
          tourne = true; traceBeam(); etat = 'p1'; t0 = performance.now();
          requestAnimationFrame(pas);
        }
      });
    }, { rootMargin: '60px 0px' }).observe(pipe);
  }
  window.addEventListener('resize', traceBeam, { passive: true });
  traceBeam();
})();

/* ── Livraison : deux parcours ── */
const tabLocale = document.getElementById('tab-locale');
const tabExpe = document.getElementById('tab-expe');
if (tabLocale && tabExpe) {
const panneauLocale = document.getElementById('panel-locale');
const panneauExpe = document.getElementById('panel-expe');
function montreParcours(local) {
  tabLocale.setAttribute('aria-selected', String(local));
  tabExpe.setAttribute('aria-selected', String(!local));
  panneauLocale.hidden = !local;
  panneauExpe.hidden = local;
}
tabLocale.addEventListener('click', () => montreParcours(true));
tabExpe.addEventListener('click', () => montreParcours(false));

/* Zone locale : distances routières approx. depuis la boutique (km) +
   position carte en km est/nord — échelle SVG 7.2 px/km, centre (260,200) */
const CFG = window.MMConfig || {};
let communesAdmin = null;
if (CFG.communesRaw) { try { communesAdmin = JSON.parse(CFG.communesRaw); } catch (e) { communesAdmin = null; } }
/* Clés = CP réels (saisie directe) ou CP+suffixe (communes qui partagent un CP
   mais pas la même distance). TOUTES les communes ≤ 20 km d'Épinal sont là. */
const COMMUNES = communesAdmin && Object.keys(communesAdmin).length ? communesAdmin : {
  '88000':   { km: 0,  dx: 0,     dy: 0,    nom: 'Épinal' },
  '88000c':  { km: 1,  dx: -1,    dy: -1,   nom: 'Chantraine' },
  '88000d':  { km: 3,  dx: 1.5,   dy: -2.5, nom: 'Dinozé' },
  '88000j':  { km: 4,  dx: 3,     dy: 2,    nom: 'Jeuxey' },
  '88000y':  { km: 5,  dx: 4.5,   dy: 2.5,  nom: 'Deyvillers' },
  '88000g':  { km: 4,  dx: 1,     dy: 4,    nom: 'Dogneville' },
  '88000l':  { km: 8,  dx: 6,     dy: 4,    nom: 'Longchamp' },
  '88000i':  { km: 8,  dx: 3,     dy: 7,    nom: 'Dignonville' },
  '88000v':  { km: 12, dx: 6,     dy: 10,   nom: 'Vaudéville' },
  '88190':   { km: 3,  dx: -2,    dy: 2.5,  nom: 'Golbey' },
  '88150':   { km: 10, dx: -2,    dy: 9.5,  nom: 'Thaon-lès-Vosges' },
  '88150c':  { km: 7,  dx: -2,    dy: 7,    nom: 'Chavelot' },
  '88150g':  { km: 9,  dx: -1,    dy: 8.5,  nom: 'Girmont' },
  '88150o':  { km: 9,  dx: -3,    dy: 8,    nom: 'Oncourt' },
  '88150i':  { km: 8,  dx: -4,    dy: 7.5,  nom: 'Igney' },
  '88150m':  { km: 9,  dx: -6,    dy: 6,    nom: 'Mazeley' },
  '88150b':  { km: 12, dx: 1,     dy: 11,   nom: 'Bayecourt' },
  '88150v':  { km: 12, dx: 4,     dy: 11,   nom: 'Villoncourt' },
  '88390':   { km: 6,  dx: -6,    dy: 1.5,  nom: 'Darnieulles' },
  '88390u':  { km: 5,  dx: -5,    dy: 1,    nom: 'Uxegney' },
  '88390f':  { km: 5,  dx: -4,    dy: -1,   nom: 'Les Forges' },
  '88390c':  { km: 8,  dx: -8,    dy: -1,   nom: 'Chaumousey' },
  '88390s':  { km: 7,  dx: -7,    dy: 0,    nom: 'Sanchey' },
  '88390r':  { km: 6,  dx: -5,    dy: -3,   nom: 'Renauvoid' },
  '88390d':  { km: 7,  dx: -6,    dy: 3,    nom: 'Domèvre-sur-Avière' },
  '88390fo': { km: 8,  dx: -7.5,  dy: 2,    nom: 'Fomerey' },
  '88390g':  { km: 9,  dx: -9,    dy: -2,   nom: 'Girancourt' },
  '88390db': { km: 12, dx: -11,   dy: -4,   nom: 'Dommartin-aux-Bois' },
  '88440':   { km: 12, dx: -3,    dy: 12,   nom: 'Nomexy' },
  '88440f':  { km: 13, dx: -4,    dy: 12,   nom: 'Frizon' },
  '88330':   { km: 15, dx: -1,    dy: 14,   nom: 'Châtel-sur-Moselle' },
  '88330v':  { km: 12, dx: -2,    dy: 11,   nom: 'Vaxoncourt' },
  '88330p':  { km: 13, dx: 0,     dy: 12,   nom: 'Pallegney' },
  '88330z':  { km: 14, dx: -1,    dy: 13,   nom: 'Zincourt' },
  '88330m':  { km: 19, dx: -2,    dy: 18,   nom: 'Moriville' },
  '88330r':  { km: 18, dx: 1,     dy: 17,   nom: 'Rehaincourt' },
  '88330po': { km: 18, dx: 0,     dy: 17,   nom: 'Portieux' },
  '88450':   { km: 19, dx: -3,    dy: 18,   nom: 'Vincey' },
  '88380':   { km: 9,  dx: 4,     dy: -9,   nom: 'Arches' },
  '88380a':  { km: 9,  dx: 5,     dy: -8,   nom: 'Archettes' },
  '88550':   { km: 12, dx: 4,     dy: -11,  nom: 'Pouxeux' },
  '88550j':  { km: 12, dx: 6,     dy: -10,  nom: 'Jarménil' },
  '88510':   { km: 15, dx: 9,     dy: -12,  nom: 'Éloyes' },
  '88200s':  { km: 18, dx: 7,     dy: -16,  nom: 'Saint-Nabord' },
  '88220':   { km: 16, dx: -6,    dy: -15,  nom: 'Xertigny' },
  '88220h':  { km: 10, dx: 0,     dy: -9,   nom: 'Hadol' },
  '88220d':  { km: 8,  dx: -2,    dy: -7,   nom: 'Dounoux' },
  '88220u':  { km: 8,  dx: -3,    dy: -6.5, nom: 'Uriménil' },
  '88220z':  { km: 11, dx: -6,    dy: -8,   nom: 'Uzemain' },
  '88220r':  { km: 14, dx: 1,     dy: -13,  nom: 'Raon-aux-Bois' },
  '88270':   { km: 17, dx: -15,   dy: 2,    nom: 'Dompaire' },
  '88270v':  { km: 18, dx: -16,   dy: -3,   nom: 'Ville-sur-Illon' },
  '88270h':  { km: 15, dx: -13,   dy: -6,   nom: 'Harol' },
  '88270g':  { km: 12, dx: -11,   dy: 0,    nom: 'Gorhey' },
  '88270he': { km: 11, dx: -10,   dy: 2,    nom: 'Hennecourt' },
  '88270b':  { km: 12, dx: -11,   dy: 3,    nom: 'Bocquegney' },
  '88270co': { km: 18, dx: -13,   dy: -11,  nom: 'Charmois-l’Orgueilleux' },
  '88460':   { km: 13, dx: 10,    dy: -5,   nom: 'Docelles' },
  '88460c':  { km: 12, dx: 9,     dy: -4,   nom: 'Cheniménil' },
  '88460b':  { km: 9,  dx: 7,     dy: -4,   nom: 'La Baffe' },
  '88460d':  { km: 15, dx: 12,    dy: -2,   nom: 'Deycimont' },
  '88460f':  { km: 16, dx: 12,    dy: -3,   nom: 'Faucompierre' },
  '88460t':  { km: 18, dx: 14,    dy: -4,   nom: 'Tendon' },
  '88460ch': { km: 14, dx: 11,    dy: 3,    nom: 'Charmois-devant-Bruyères' },
  '88460r':  { km: 15, dx: 11,    dy: 5,    nom: 'Le Roulier' },
  '88600':   { km: 18, dx: 15,    dy: 9,    nom: 'Bruyères' },
  '88600a':  { km: 9,  dx: 8,     dy: 3,    nom: 'Aydoilles' },
  '88600f':  { km: 10, dx: 9,     dy: 4.5,  nom: 'Fontenay' },
  '88600s':  { km: 12, dx: 7,     dy: 9,    nom: 'Sercœur' },
  '88600d':  { km: 11, dx: 8,     dy: 8,    nom: 'Dompierre' },
  '88600l':  { km: 16, dx: 13,    dy: 1,    nom: 'Lépanges-sur-Vologne' },
  '88600fa': { km: 14, dx: 11,    dy: 6,    nom: 'Fays' },
  '88600g':  { km: 17, dx: 13,    dy: 8,    nom: 'Grandvillers' },
  '88600v':  { km: 16, dx: 12,    dy: 7,    nom: 'Viménil' },
  '88600m':  { km: 17, dx: 13,    dy: 5,    nom: 'Méménil' },
  '88600gu': { km: 18, dx: 14,    dy: 6,    nom: 'Gugnécourt' },
  '88600n':  { km: 18, dx: 14,    dy: 8,    nom: 'Nonzeville' },
  '88700p':  { km: 14, dx: 9,     dy: 11,   nom: 'Padoux' },
  '88100':   { km: 48, dx: 34,    dy: 28,   nom: 'Saint-Dié-des-Vosges' },
  '88130':   { km: 24, dx: -8,    dy: 23,   nom: 'Charmes' },
  '88200':   { km: 26, dx: 8,     dy: -24,  nom: 'Remiremont' },
  '88700':   { km: 27, dx: 12,    dy: 24,   nom: 'Rambervillers' },
  '88400':   { km: 30, dx: 28,    dy: -12,  nom: 'Gérardmer' },
  '88160':   { km: 35, dx: 18,    dy: -30,  nom: 'Le Thillot' }
};
const ZONE_KM = CFG.zoneKm || 20;
/* Résolution par NOM de ville (des villes différentes partagent parfois un CP) */
const VILLES = {
  'epinal': '88000', 'chantraine': '88000c', 'dinoze': '88000d',
  'jeuxey': '88000j', 'deyvillers': '88000y', 'dogneville': '88000g',
  'longchamp': '88000l', 'dignonville': '88000i', 'vaudeville': '88000v',
  'golbey': '88190',
  'thaon': '88150', 'thaonlesvosges': '88150', 'capavenirvosges': '88150',
  'chavelot': '88150c', 'girmont': '88150g', 'oncourt': '88150o', 'igney': '88150i',
  'mazeley': '88150m', 'bayecourt': '88150b', 'villoncourt': '88150v',
  'darnieulles': '88390', 'uxegney': '88390u', 'lesforges': '88390f',
  'chaumousey': '88390c', 'sanchey': '88390s', 'renauvoid': '88390r',
  'domevresuraviere': '88390d', 'fomerey': '88390fo', 'girancourt': '88390g',
  'dommartinauxbois': '88390db',
  'nomexy': '88440', 'frizon': '88440f',
  'chatelsurmoselle': '88330', 'chatel': '88330', 'vaxoncourt': '88330v',
  'pallegney': '88330p', 'zincourt': '88330z', 'moriville': '88330m',
  'rehaincourt': '88330r', 'portieux': '88330po', 'vincey': '88450',
  'arches': '88380', 'archettes': '88380a', 'pouxeux': '88550', 'jarmenil': '88550j',
  'eloyes': '88510', 'saintnabord': '88200s',
  'xertigny': '88220', 'hadol': '88220h', 'dounoux': '88220d', 'urimenil': '88220u',
  'uzemain': '88220z', 'raonauxbois': '88220r',
  'dompaire': '88270', 'villesurillon': '88270v', 'harol': '88270h', 'gorhey': '88270g',
  'hennecourt': '88270he', 'bocquegney': '88270b', 'charmoislorgueilleux': '88270co',
  'docelles': '88460', 'chenimenil': '88460c', 'labaffe': '88460b', 'deycimont': '88460d',
  'faucompierre': '88460f', 'tendon': '88460t', 'charmoisdevantbruyeres': '88460ch',
  'leroulier': '88460r',
  'bruyeres': '88600', 'aydoilles': '88600a', 'fontenay': '88600f', 'sercoeur': '88600s',
  'dompierre': '88600d', 'lepangessurvologne': '88600l', 'fays': '88600fa',
  'grandvillers': '88600g', 'vimenil': '88600v', 'memenil': '88600m',
  'gugnecourt': '88600gu', 'nonzeville': '88600n', 'padoux': '88700p',
  'charmes': '88130', 'remiremont': '88200', 'rambervillers': '88700',
  'gerardmer': '88400', 'lethillot': '88160', 'saintdie': '88100', 'saintdiedesvosges': '88100'
};
const normalise = (t) => t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
const clientPin = document.getElementById('client-pin');
const trace = document.getElementById('trace');
const resLocale = document.getElementById('res-locale');
const icoLocale = document.getElementById('ico-locale').querySelector('use');
const titreLocale = document.getElementById('titre-locale');
const texteLocale = document.getElementById('texte-locale');

function poseClient(dx, dy) {
  const px = 260 + dx * 7.2, py = 200 - dy * 7.2;
  clientPin.setAttribute('transform', `translate(${px} ${py})`);
  const mx = (260 + px) / 2 + (py - 200) * 0.18;
  const my = (200 + py) / 2 + (260 - px) * 0.18;
  trace.setAttribute('d', `M260 200 Q ${mx} ${my} ${px} ${py}`);
  trace.classList.remove('actif'); clientPin.classList.remove('actif');
  void trace.getBoundingClientRect();
  trace.classList.add('actif'); clientPin.classList.add('actif');
}
function effaceClient() {
  trace.classList.remove('actif'); clientPin.classList.remove('actif');
}

const BOUTIQUE = { lat: 48.1747, lon: 6.4491 }; /* Épinal centre */
/* Zone locale confirmée : sert aussi aux produits qui ne s'expédient pas (glaces). */
function memoriseZone(estLocale) {
  try { localStorage.setItem('mm-zone-locale', estLocale ? '1' : '0'); } catch (e) {}
  document.documentElement.classList.toggle('zone-locale', !!estLocale);
}
function kmEntre(lat, lon) {
  const R = 6371, rad = Math.PI / 180;
  const dLat = (lat - BOUTIQUE.lat) * rad, dLon = (lon - BOUTIQUE.lon) * rad;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(BOUTIQUE.lat * rad) * Math.cos(lat * rad) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}
async function geocode(q) {
  const r = await fetch('https://api-adresse.data.gouv.fr/search/?limit=1&q=' + encodeURIComponent(q));
  if (!r.ok) return null;
  const js = await r.json();
  const f = js.features && js.features[0];
  if (!f) return null;
  const [lon, lat] = f.geometry.coordinates;
  return { lat, lon, nom: f.properties.city || f.properties.label, cp: f.properties.postcode || '' };
}
/* Autocomplétion : communes réelles pendant la frappe */
const champCP = document.getElementById('cp-locale');
const dl = document.getElementById('villes-88');
if (champCP && dl) {
  let tAuto;
  champCP.addEventListener('input', () => {
    clearTimeout(tAuto);
    const q = champCP.value.trim();
    if (q.length < 3 || /^\d+$/.test(q)) return;
    tAuto = setTimeout(async () => {
      try {
        const r = await fetch('https://api-adresse.data.gouv.fr/search/?type=municipality&limit=5&q=' + encodeURIComponent(q));
        const js = await r.json();
        dl.innerHTML = (js.features || []).map((f) => `<option value="${f.properties.city} (${f.properties.postcode})"></option>`).join('');
      } catch (err) { /* silencieux */ }
    }, 280);
  });
}
document.getElementById('form-locale').addEventListener('submit', async (e) => {
  e.preventDefault();
  const brut = document.getElementById('cp-locale').value.trim().replace(/\s*\(\d{5}\)$/, '');
  /* Ville d'abord (plus précis quand un CP est partagé), sinon code postal */
  const cp = /^\d{5}$/.test(brut) ? brut : (VILLES[normalise(brut)] || '');
  let icone = '#i-scooter', t = '', d = '';
  if (!cp && brut.length >= 2) {
    /* Inconnue de la liste locale → géocodage réel France entière */
    titreLocale.textContent = 'On regarde la carte…'; texteLocale.textContent = '';
    resLocale.classList.add('visible');
    let geo = null;
    try { geo = await geocode(brut); } catch (err) { geo = null; }
    if (geo) {
      const km = Math.round(kmEntre(geo.lat, geo.lon));
      const rad = Math.PI / 180;
      const dx = (geo.lon - BOUTIQUE.lon) * Math.cos(BOUTIQUE.lat * rad) * 111.32;
      const dy = (geo.lat - BOUTIQUE.lat) * 110.57;
      if (km <= ZONE_KM) {
        poseClient(dx, dy);
        memoriseZone(true);
        icoLocale.setAttribute('href', '#i-scooter');
        titreLocale.textContent = `${geo.nom} : t'es dans la zone !`;
        texteLocale.textContent = km <= 1
          ? 'À deux pas de la boutique : commandé, livré.'
          : `≈ ${km} km de la boutique : on te livre en scooter pendant l'ouverture.`;
      } else if (km <= 90) {
        poseClient(dx, dy);
        icoLocale.setAttribute('href', '#i-colis');
        titreLocale.textContent = `${geo.nom}, un poil trop loin pour le scooter`;
        texteLocale.textContent = `≈ ${km} km : au-delà de nos ${ZONE_KM} km. Mais le colis suivi arrive en 48h, offert dès 100 €.`;
      } else {
        effaceClient();
        montreParcours(false);
        const fe = document.getElementById('form-expe');
        if (fe) fe.dispatchEvent(new Event('submit', { cancelable: true }));
        return;
      }
    } else {
      effaceClient();
      icoLocale.setAttribute('href', '#i-pin');
      titreLocale.textContent = 'On n\'a pas trouvé ce coin';
      texteLocale.textContent = 'Essaie ta ville (ex. Golbey) ou ton code postal à 5 chiffres.';
    }
    resLocale.classList.remove('visible'); void resLocale.offsetWidth; resLocale.classList.add('visible');
    return;
  }
  if (!cp) {
    icone = '#i-pin'; t = 'On n\'a pas trouvé ce coin';
    d = 'Essaie ta ville ou ton code postal à 5 chiffres.';
    effaceClient();
  } else if (!cp.startsWith('88')) {
    effaceClient();
    montreParcours(false);
    document.getElementById('form-expe').dispatchEvent(new Event('submit', { cancelable: true }));
    return;
  } else if (COMMUNES[cp]) {
    const c = COMMUNES[cp];
    poseClient(c.dx, c.dy);
    if (c.km <= ZONE_KM) {
      memoriseZone(true);
      t = `${c.nom} : t'es dans la zone !`;
      d = c.km === 0
        ? 'À deux pas de la boutique : commandé, livré.'
        : `≈ ${c.km} km de la boutique : on te livre en scooter pendant l'ouverture.`;
    } else {
      icone = '#i-colis';
      t = `${c.nom}, un poil trop loin pour le scooter`;
      d = `≈ ${c.km} km : au-delà de nos ${ZONE_KM} km. Mais le colis suivi arrive en 48h, offert dès 100 €.`;
    }
  } else {
    effaceClient();
    icone = '#i-pin';
    t = 'On connaît pas ce coin par cœur';
    d = `Si t'es à moins de ${ZONE_KM} km d'Épinal, on livre en scooter. Sinon, le colis 48h prend le relais, offert dès 100 €.`;
  }
  icoLocale.setAttribute('href', icone);
  titreLocale.textContent = t;
  texteLocale.textContent = d;
  resLocale.classList.remove('visible');
  void resLocale.offsetWidth;
  resLocale.classList.add('visible');
});

/* Expédition : timeline animée par destination */
const DESTINATIONS = {
  FR:    { delai: 'Chez toi en 48-72h', note: 'suivi — 8,90 €, offert dès 100 €', extra: 'Colissimo suivi partout en France métropolitaine : 8,90 €, et on te l\'offre dès 100 € de panier.' },
  BE:    { delai: 'Chez toi en 3-5 jours', note: 'colis suivi', extra: 'Expédition suivie vers la Belgique — frais calculés au checkout.' },
  LU:    { delai: 'Chez toi en 3-5 jours', note: 'colis suivi', extra: 'Expédition suivie vers le Luxembourg — frais calculés au checkout.' },
  CH:    { delai: 'Chez toi en 5-8 jours', note: 'colis suivi', extra: 'Frais calculés au checkout. Les éventuels frais de douane suisses restent à ta charge.' },
  DE:    { delai: 'Chez toi en 3-5 jours', note: 'colis suivi', extra: 'Expédition suivie vers l\'Allemagne — frais calculés au checkout.' },
  EU:    { delai: 'Chez toi en 3-7 jours', note: 'colis suivi', extra: 'Toute l\'Europe, emballage renforcé pour le verre — frais calculés au checkout.' },
  WORLD: { delai: 'Chez toi en 5-15 jours', note: 'colis suivi', extra: 'On traverse les océans — frais calculés au checkout, droits de douane à ta charge.' }
};
document.querySelectorAll('.puce-dest').forEach((p) => {
  p.addEventListener('click', () => {
    document.querySelectorAll('.puce-dest').forEach((x) => x.setAttribute('aria-pressed', 'false'));
    p.setAttribute('aria-pressed', 'true');
    const sel = document.getElementById('pays-expe');
    if (sel) sel.value = p.dataset.dest;
    document.getElementById('form-expe').dispatchEvent(new Event('submit', { cancelable: true }));
  });
});
document.getElementById('form-expe').addEventListener('submit', (e) => {
  e.preventDefault();
  const dst = DESTINATIONS[document.getElementById('pays-expe').value];
  const arc = document.getElementById('arc-voyage');
  if (arc) { arc.classList.remove('actif'); void arc.offsetWidth; if (animOK()) arc.classList.add('actif'); }
  const nomDest = document.querySelector('.puce-dest[aria-pressed="true"] span:last-child');
  const lbl = document.getElementById('arc-dest-label');
  if (lbl && nomDest) lbl.textContent = nomDest.textContent;
  document.getElementById('etape-delai').textContent = dst.delai;
  document.getElementById('etape-note').textContent = dst.note;
  document.getElementById('note-expe').textContent = dst.extra;
  const tl = document.getElementById('timeline-expe');
  tl.classList.remove('visible');
  void tl.offsetWidth;
  tl.classList.add('visible');
});
} /* fin section livraison */

/* ── Age-gate : auto sur les pages 18+, à la demande sur les cartes floutées ── */
const ageGate = document.getElementById('age-gate');
const estMajeur = () => { try { return !!sessionStorage.getItem('mm-majeur'); } catch (e) { return false; } };
function ouvreAgeGate() {
  if (!ageGate) return;
  ageGate.hidden = false;
  document.documentElement.style.overflow = 'hidden';
}
if (ageGate) {
  const oui = document.getElementById('age-oui');
  if (oui) oui.addEventListener('click', () => {
    try { sessionStorage.setItem('mm-majeur', '1'); } catch (e) {}
    document.documentElement.classList.add('majeur-ok');
    ageGate.hidden = true;
    document.documentElement.style.overflow = '';
  });
  if (ageGate.dataset.auto === 'true' && !estMajeur()) ouvreAgeGate();
  /* Cartes 18+ floutées : le clic demande l'âge au lieu de naviguer */
  document.addEventListener('click', (e) => {
    if (estMajeur()) return;
    const carte = e.target.closest('.carte-18');
    if (!carte) return;
    e.preventDefault();
    e.stopPropagation();
    ouvreAgeGate();
  }, true);
}


/* ── Mot rotatif (adapté Text Rotate 21st : lettres qui montent en cascade
      ressort, l'ancien mot file vers le haut) ── */
document.querySelectorAll('.mot-rotatif').forEach((rot) => {
  const mots = [...rot.children];
  if (mots.length < 2) { if (mots[0]) mots[0].classList.add('actif'); return; }
  if (!reduceOS) {
    mots.forEach((m) => {
      const txt = m.textContent;
      m.textContent = '';
      m.setAttribute('aria-label', txt);
      txt.split('').forEach((c, i) => {
        if (/\s/.test(c)) { m.appendChild(document.createTextNode(c)); return; }
        const l = document.createElement('i');
        l.className = 'rl'; l.textContent = c;
        l.setAttribute('aria-hidden', 'true');
        l.style.setProperty('--li', i);
        m.appendChild(l);
      });
    });
  }
  let iR = 0;
  mots[0].classList.add('actif');
  setInterval(() => {
    if (!animOK() || document.visibilityState !== 'visible') return;
    const ancien = mots[iR];
    ancien.classList.remove('actif');
    ancien.classList.add('sort');
    setTimeout(() => ancien.classList.remove('sort'), 620);
    iR = (iR + 1) % mots.length;
    mots[iR].classList.add('actif');
  }, 2600);
});

/* ── Fiche produit : quantité + ajout AJAX avec morph ── */
const formProduit = document.querySelector('.produit-fiche form[action*="/cart/add"]');
if (formProduit) {
  const moins = formProduit.querySelector('.qte-moins');
  const plus = formProduit.querySelector('.qte-plus');
  const champQ = formProduit.querySelector('input[name="quantity"]');
  if (moins && plus && champQ) {
    moins.addEventListener('click', () => { champQ.value = Math.max(1, parseInt(champQ.value, 10) - 1); });
    plus.addEventListener('click', () => { champQ.value = parseInt(champQ.value, 10) + 1; });
  }
  formProduit.addEventListener('submit', (e) => {
    e.preventDefault();
    const btn = formProduit.querySelector('button[type="submit"]');
    const lblB = btn.querySelector('.lbl') || btn;
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(formProduit) })
      .then((r) => r.ok ? fetch('/cart.js').then((c) => c.json()) : Promise.reject())
      .then((cart) => {
        const bc = document.getElementById('panier-count');
        if (bc) { bc.textContent = cart.item_count; bc.classList.remove('pop'); void bc.offsetWidth; bc.classList.add('pop'); }
        lblB.textContent = 'Ajouté ✓';
        if (typeof popCandy === 'function' && animOK()) popCandy(document.querySelector('.achat-sticky .btn'));
        if (typeof montreToast === 'function') montreToast("C'est dans le sac !", (document.querySelector('.p-titre') || {}).textContent || '', 'Voir le panier', '/cart');
        setTimeout(() => { lblB.textContent = lblB.dataset.initial || 'Ajouter au panier'; }, 1600);
      })
      .catch(() => { lblB.textContent = 'Oups, réessaie'; })
      .finally(() => { btn.disabled = false; });
  });
}


/* ── Fiche produit : le prix du bouton suit la variante choisie ── */
const selVariante = document.querySelector('.produit-fiche select[name="id"]');
if (selVariante) {
  selVariante.addEventListener('change', () => {
    const opt = selVariante.options[selVariante.selectedIndex];
    const prix = (opt.textContent.split('—')[1] || '').replace(/\(.*\)/, '').trim();
    const lblB = document.querySelector('.achat-sticky .lbl');
    if (lblB && prix) {
      const neuf = 'Ajouter au panier — ' + prix;
      lblB.textContent = neuf;
      lblB.dataset.initial = neuf;
    }
  });
}

/* ── Panier : la quantité se met à jour toute seule ── */
document.querySelectorAll('.panier-page input[name="updates[]"]').forEach((champ) => {
  champ.addEventListener('change', () => champ.closest('form').submit());
});


/* ── Mobile : le carrousel de stats vit tout seul, s'arrête dès qu'on le touche ── */
const railStats = document.querySelector('.hero-stats');
if (railStats && window.matchMedia('(max-width: 720px)').matches && animOK()) {
  let iS = 0, pauseS = false, tReprise;
  ['touchstart', 'pointerdown'].forEach((ev) => railStats.addEventListener(ev, () => {
    pauseS = true; clearTimeout(tReprise);
    tReprise = setTimeout(() => { pauseS = false; }, 5000);
  }, { passive: true }));
  setInterval(() => {
    if (pauseS || document.visibilityState !== 'visible') return;
    const cartes = railStats.children;
    if (!cartes.length) return;
    iS = (iS + 1) % cartes.length;
    railStats.scrollTo({ left: cartes[iS].offsetLeft - railStats.offsetLeft, behavior: 'smooth' });
  }, 3200);
}


/* ── Cookies : bannière MIDI MINUIT branchée sur l'API Customer Privacy ── */
(function () {
  const boite = document.getElementById('cookies-mm');
  if (!boite) return;
  const CLE = 'mm-cookies';
  const dejaChoisi = localStorage.getItem(CLE);
  let api = null;
  function applique(ok) {
    boite.hidden = true; /* on ferme D'ABORD — l'API ne doit jamais bloquer l'UI */
    localStorage.setItem(CLE, ok ? 'oui' : 'non');
    try {
      if (api && api.setTrackingConsent) {
        api.setTrackingConsent(
          { analytics: ok, marketing: ok, preferences: ok, sale_of_data: ok },
          function () {}
        );
      }
    } catch (e) { /* consentement stocké localement, on n'interrompt rien */ }
  }
  function montreSiBesoin() {
    if (dejaChoisi) {
      /* Choix déjà fait : on le rejoue silencieusement vers l'API */
      if (api && api.setTrackingConsent) {
        const ok = dejaChoisi === 'oui';
        api.setTrackingConsent({ analytics: ok, marketing: ok, preferences: ok, sale_of_data: ok }, function () {});
      }
      return;
    }
    let doitMontrer = true;
    if (api) {
      if (typeof api.shouldShowBanner === 'function') doitMontrer = api.shouldShowBanner();
      else if (typeof api.shouldShowGDPRBanner === 'function') doitMontrer = api.shouldShowGDPRBanner();
    }
    /* Si la bannière native Shopify est encore active (réglage admin), on
       s'efface : jamais deux bannières. La nôtre prend le relais dès que la
       native est désactivée dans Paramètres → Vie privée des clients. */
    if (document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog')) doitMontrer = false;
    if (doitMontrer) boite.hidden = false;
  }
  document.getElementById('cookies-oui').addEventListener('click', function () { applique(true); });
  document.getElementById('cookies-non').addEventListener('click', function () { applique(false); });
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err && window.Shopify.customerPrivacy) api = window.Shopify.customerPrivacy;
      montreSiBesoin();
    });
  } else {
    montreSiBesoin();
  }
})();


/* ── Bundle fiche produit : les 2 d'un coup ── */
const bundleBtn = document.getElementById('bundle-btn');
if (bundleBtn) {
  bundleBtn.addEventListener('click', () => {
    bundleBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [
        { id: parseInt(bundleBtn.dataset.v1, 10), quantity: 1 },
        { id: parseInt(bundleBtn.dataset.v2, 10), quantity: 1 }
      ]})
    }).then((r) => r.ok ? fetch('/cart.js').then((c) => c.json()) : Promise.reject())
      .then((cart) => {
        const bc = document.getElementById('panier-count');
        if (bc) { bc.textContent = cart.item_count; bc.classList.remove('pop'); void bc.offsetWidth; bc.classList.add('pop'); }
        bundleBtn.textContent = 'Ajoutés ✓';
        setTimeout(() => { bundleBtn.textContent = 'Ajouter les 2'; bundleBtn.disabled = false; }, 1800);
      })
      .catch(() => { bundleBtn.textContent = 'Oups, réessaie'; bundleBtn.disabled = false; });
  });
}

/* ── Panier : steppers +/− branchés sur /cart/change.js (mutation réelle) ── */
function majPanierDOM(cart) {
  const bc = document.getElementById('panier-count');
  if (bc) bc.textContent = cart.item_count;
  const total = document.querySelector('.total-ligne b');
  if (total && cart.total_price !== undefined) {
    const arrivee = cart.total_price / 100;
    const depart = parseFloat((total.textContent || '0').replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
    if (!animOK() || Math.abs(arrivee - depart) < 0.005) {
      total.textContent = '€' + arrivee.toFixed(2).replace('.', ',');
    } else {
      const t0 = performance.now();
      (function compte(t) {
        const p = Math.min(1, (t - t0) / 420);
        const e = 1 - Math.pow(1 - p, 3);
        total.textContent = '€' + (depart + (arrivee - depart) * e).toFixed(2).replace('.', ',');
        if (p < 1) requestAnimationFrame(compte);
      })(t0);
    }
  }
  const franco = document.querySelector('.franco');
  if (franco) {
    const seuil = 10000;
    const pct = Math.min(100, Math.round(cart.total_price * 100 / seuil));
    const barre = franco.querySelector('.barre-seuil i');
    const curseur = franco.querySelector('.curseur-franco');
    const texte = franco.querySelector('.franco-txt');
    if (barre) barre.style.width = pct + '%';
    if (curseur) curseur.style.left = pct + '%';
    franco.classList.toggle('franco-ok', cart.total_price >= seuil);
    if (texte) texte.innerHTML = cart.total_price >= seuil
      ? 'Livraison offerte — <b>c\u2019est cadeau.</b>'
      : 'Encore <b>€' + ((seuil - cart.total_price) / 100).toFixed(2).replace('.', ',') + '</b> et la livraison est <b>offerte</b>';
  }
}
document.querySelectorAll('.qte-panier').forEach((b) => {
  b.addEventListener('click', () => {
    const item = b.closest('.item-panier');
    const champ = b.parentElement.querySelector('input');
    const cible = Math.max(0, parseInt(champ.value, 10) + parseInt(b.dataset.delta, 10));
    champ.value = cible;
    champ.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: b.dataset.cle, quantity: cible })
    }).then((r) => r.json()).then((cart) => {
      champ.disabled = false;
      if (cible === 0) {
        if (item && animOK()) {
          item.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(30px) scale(0.96)' }], { duration: 260, easing: 'ease-out' }).onfinish = () => { item.remove(); if (cart.item_count === 0) location.reload(); };
        } else { item && item.remove(); if (cart.item_count === 0) location.reload(); }
      } else {
        const ligne = cart.items.find((i) => i.key === b.dataset.cle);
        if (ligne && item) { const prix = item.querySelector('div[style*="text-align"] p'); if (prix) prix.textContent = '€' + (ligne.final_line_price / 100).toFixed(2).replace('.', ','); }
      }
      majPanierDOM(cart);
    }).catch(() => { champ.disabled = false; });
  });
});


/* ══════════════════════════════════════════════════════════════════
   GSAP ScrollTrigger (officiel, local) — ENRICHISSEMENT.
   S'il est là : reveals batch + parallaxe scrub nuages/flotteurs.
   S'il manque : tout le site fonctionne déjà sans lui (IO reveals).
   ══════════════════════════════════════════════════════════════════ */
(function () {
  if (!animOK() || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);
  document.documentElement.classList.add("gsap-pret");

  /* Reveals : batch fluide (remplace la version IO quand GSAP est présent) */
  ScrollTrigger.batch(".reveal:not(.vu)", {
    start: "top 88%",
    once: true,
    onEnter: (lot) => gsap.fromTo(lot,
      { opacity: 0, y: 26 },
      { opacity: 1, y: 0, duration: 0.7, stagger: 0.08, ease: "power3.out", overwrite: true,
        onComplete: () => lot.forEach((el) => el.classList.add("vu")) })
  });

  /* Parallaxe scrub : les flotteurs du héros dérivent avec le scroll */
  gsap.utils.toArray(".flotteur").forEach((el, i) => {
    gsap.to(el, {
      y: i % 2 ? -70 : -110,
      ease: "none",
      scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: 0.6 }
    });
  });

  /* Le logo sticker s'éloigne doucement */
  const sticker = document.querySelector(".sticker-logo");
  if (sticker) {
    gsap.to(sticker, {
      y: -60, rotation: 14, ease: "none",
      scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: 0.8 }
    });
  }

  /* Les tickets promesses arrivent en éventail scrubbé */
  gsap.utils.toArray(".ticket").forEach((el, i) => {
    gsap.from(el, {
      y: 46, rotation: (i % 2 ? 3 : -3),
      ease: "none",
      scrollTrigger: { trigger: el, start: "top 100%", end: "top 68%", scrub: 0.4 }
    });
  });
})();

/* ── Estimation de livraison dynamique (fiche produit) ── */
(function () {
  const cible = document.querySelector('[data-estime-livraison]');
  if (!cible) return;
  const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  const ouvres = (n) => { const x = new Date(); let a = 0; while (a < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0) a++; } return x; };
  cible.textContent = 'entre ' + fmt.format(ouvres(2)) + ' et ' + fmt.format(ouvres(4));
})();

/* ══════════════════════════════════════════════════════════════
   PACK 21st v12 — cadre pointé, progression slush, confettis candy
   ══════════════════════════════════════════════════════════════ */

/* ── Cadre pointé (port vanilla de « pointer-highlight ») :
   un rectangle magenta se dessine autour de l'accent des titres
   de pages internes, puis le curseur se pose au coin. ── */
(function () {
  if (reduceOS) return;
  const cibles = document.querySelectorAll('.page-mm h1 .accent-catch, [data-pointeur] .accent-catch');
  if (!cibles.length) return;
  cibles.forEach((accent) => {
    accent.classList.add('avec-cadre');
    const cadre = document.createElement('span');
    cadre.className = 'ph-cadre';
    cadre.setAttribute('aria-hidden', 'true');
    const curseur = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    curseur.setAttribute('viewBox', '0 0 16 16');
    curseur.setAttribute('class', 'ph-curseur');
    curseur.setAttribute('aria-hidden', 'true');
    curseur.innerHTML = '<path fill="currentColor" d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103z"/>';
    accent.appendChild(cadre);
    accent.appendChild(curseur);
    const io = new IntersectionObserver((es) => {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      const larg = accent.offsetWidth, haut = accent.offsetHeight;
      cadre.animate(
        [{ width: '0px', height: '0px' }, { width: larg + 8 + 'px', height: '0px', offset: 0.5 }, { width: larg + 8 + 'px', height: haut + 6 + 'px' }],
        { duration: 900, easing: 'cubic-bezier(0.77, 0, 0.175, 1)', fill: 'forwards', delay: 250 }
      );
      curseur.animate(
        [{ opacity: 0, transform: 'translate(0, 0) rotate(-90deg)' },
         { opacity: 1, transform: `translate(${larg + 6}px, ${haut + 4}px) rotate(-90deg)` }],
        { duration: 900, easing: 'cubic-bezier(0.77, 0, 0.175, 1)', fill: 'forwards', delay: 350 }
      );
    }, { rootMargin: '0px 0px -8% 0px' });
    io.observe(accent);
  });
})();

/* ── Barre de progression slush : où en es-tu dans la page ? ── */
(function () {
  const barre = document.createElement('div');
  barre.id = 'barre-scroll';
  barre.setAttribute('aria-hidden', 'true');
  document.body.appendChild(barre);
  let planifie = false;
  function maj() {
    planifie = false;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    barre.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, window.scrollY / max) : 0) + ')';
  }
  window.addEventListener('scroll', () => { if (!planifie) { planifie = true; requestAnimationFrame(maj); } }, { passive: true });
  maj();
})();

/* ── Confettis candy (port vanilla de « Party Popper », params GSAP d'origine) :
   l'ajout au panier fait éclater des bonbons rose/cyan. ── */
const COULEURS_CANDY = ['#F820A8', '#38E8F0', '#E878E0', '#d5188f', '#FFF5FC', '#ffffff'];
function popCandy(declencheur) {
  if (!animOK() || typeof gsap === 'undefined') return;
  const r = declencheur.getBoundingClientRect();
  const ox = r.left + r.width / 2, oy = r.top + r.height / 2;
  const alea = (min, max) => Math.random() * (max - min) + min;
  const teinte = () => COULEURS_CANDY[Math.floor(Math.random() * COULEURS_CANDY.length)];
  let conteneur = document.getElementById('candy-pop');
  if (!conteneur) {
    conteneur = document.createElement('div');
    conteneur.id = 'candy-pop';
    conteneur.setAttribute('aria-hidden', 'true');
    document.body.appendChild(conteneur);
  }
  /* particules : bonbons ronds + carrés, vers le haut (direction "up" du composant) */
  for (let i = 0; i < 14; i++) {
    const p = document.createElement('i');
    const taille = alea(7, 12);
    p.style.cssText = 'left:' + ox + 'px;top:' + oy + 'px;width:' + taille + 'px;height:' + taille + 'px;background:' + teinte() + ';border-radius:' + (i % 3 === 0 ? '3px' : '50%');
    conteneur.appendChild(p);
    const angle = 270 + alea(-60, 60);
    const v = alea(200, 400);
    const duree = alea(1.2, 2);
    const tl = gsap.timeline({ onComplete: () => p.remove() });
    tl.to(p, { duration: duree * 0.6, ease: 'power2.out', rotation: alea(-360, 360), x: Math.cos(angle * Math.PI / 180) * v * duree * 0.8, y: Math.sin(angle * Math.PI / 180) * v * duree * 0.8 });
    tl.to(p, { duration: 0.9, ease: 'power1.in', rotation: '+=' + alea(-180, 180), y: '+=' + alea(100, 200) }, '-=0.2');
    tl.to(p, { duration: 0.7, ease: 'power2.out', opacity: 0 }, '-=0.55');
  }
  /* serpentins */
  for (let i = 0; i < 4; i++) {
    const s = document.createElement('i');
    s.style.cssText = 'left:' + ox + 'px;top:' + oy + 'px;width:' + alea(25, 35) + 'px;height:' + alea(4, 6) + 'px;background:' + teinte() + ';border-radius:2px';
    conteneur.appendChild(s);
    const angle = 270 + alea(-40, 40);
    const v = alea(450, 550);
    const tl = gsap.timeline({ onComplete: () => s.remove() });
    tl.to(s, { duration: 1, ease: 'power2.out', rotation: alea(-360, 360), x: Math.cos(angle * Math.PI / 180) * v, y: Math.sin(angle * Math.PI / 180) * v });
    tl.to(s, { duration: 1.1, ease: 'power2.in', rotation: '+=' + alea(-180, 180), y: '+=250' }, '-=0.1');
    tl.to(s, { duration: 0.9, ease: 'power2.out', opacity: 0 }, '-=0.7');
  }
}

/* ══════════════════════════════════════════════════════════════
   FOURNÉE 21st v13 — palette de recherche, dock, roll nav,
   FAQ animée, filtre dispo, zoom produit, curseur candy
   ══════════════════════════════════════════════════════════════ */

/* ── Palette de recherche prédictive (command palette portée vanilla) ── */
(function () {
  const palette = document.getElementById('palette-recherche');
  if (!palette) return;
  const champ = document.getElementById('palette-input');
  const resultats = document.getElementById('palette-resultats');
  const lienTout = document.getElementById('palette-tout');
  let selection = -1, minuteur = null, derniereRequete = '';

  const ouvre = (graine) => {
    palette.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (graine) champ.value = graine;
    champ.focus({ preventScroll: true });
    montreRecents();
    if (champ.value) cherche(champ.value);
  };
  const ferme = () => {
    palette.hidden = true;
    document.documentElement.style.overflow = '';
  };

  const recents = () => { try { return JSON.parse(localStorage.getItem('mm-recherches') || '[]'); } catch (e) { return []; } };
  const retiens = (q) => {
    const r = [q].concat(recents().filter((x) => x !== q)).slice(0, 5);
    try { localStorage.setItem('mm-recherches', JSON.stringify(r)); } catch (e) {}
  };

  function montreRecents() {
    const r = recents();
    if (champ.value || !r.length) { if (!champ.value) resultats.innerHTML = '<p class="palette-vide">Tape une envie : soda, chips, matcha…</p>'; return; }
    resultats.innerHTML = '<p class="palette-groupe">Tes dernières envies</p>' +
      r.map((q) => '<button type="button" class="palette-ligne palette-recent" data-q="' + q.replace(/"/g, '&quot;') + '"><svg class="icon"><use href="#i-loupe"/></svg><span>' + q + '</span></button>').join('');
  }

  function cherche(q) {
    derniereRequete = q;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=last')
      .then((r) => r.json())
      .then((d) => {
        if (q !== derniereRequete) return;
        const produits = (((d.resources || {}).results || {}).products) || [];
        lienTout.href = '/search?q=' + encodeURIComponent(q);
        if (!produits.length) {
          resultats.innerHTML = '<p class="palette-vide">Rien pour « ' + q + ' »… mais le prochain arrivage ne devrait pas tarder.</p>';
          return;
        }
        resultats.innerHTML = produits.map((p) =>
          '<a class="palette-ligne" href="' + p.url + '">' +
          (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" width="48" height="48" loading="lazy">' : '<span class="palette-ph"></span>') +
          '<span class="palette-nom">' + p.title + '</span>' +
          '<b class="palette-prix chiffre">' + (p.price ? p.price + ' €' : '') + '</b></a>'
        ).join('');
        selection = -1;
      }).catch(() => {});
  }

  champ.addEventListener('input', () => {
    const q = champ.value.trim();
    clearTimeout(minuteur);
    if (!q) { montreRecents(); return; }
    resultats.innerHTML = '<div class="palette-squelette"><i></i><i></i><i></i></div>';
    minuteur = setTimeout(() => cherche(q), 180);
  });
  champ.closest('form').addEventListener('submit', () => { if (champ.value.trim()) retiens(champ.value.trim()); });

  palette.addEventListener('click', (e) => {
    if (e.target.closest('[data-ferme-palette]')) ferme();
    const rec = e.target.closest('.palette-recent');
    if (rec) { champ.value = rec.dataset.q; cherche(rec.dataset.q); champ.focus(); }
    const ligne = e.target.closest('a.palette-ligne');
    if (ligne && champ.value.trim()) retiens(champ.value.trim());
  });

  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); palette.hidden ? ouvre() : ferme(); return; }
    if (palette.hidden) return;
    if (e.key === 'Escape') { ferme(); return; }
    const lignes = resultats.querySelectorAll('.palette-ligne');
    if (!lignes.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      selection = e.key === 'ArrowDown' ? (selection + 1) % lignes.length : (selection - 1 + lignes.length) % lignes.length;
      lignes.forEach((l, i) => l.classList.toggle('vise', i === selection));
      lignes[selection].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && selection >= 0) {
      e.preventDefault(); lignes[selection].click();
    }
  });

  document.querySelectorAll('[data-ouvre-recherche]').forEach((b) => b.addEventListener('click', () => ouvre()));
  /* Le champ du header délègue à la palette (le form reste fonctionnel sans JS) */
  const champHeader = document.querySelector('.recherche input');
  if (champHeader) champHeader.addEventListener('focus', () => { ouvre(champHeader.value); champHeader.blur(); });
})();

/* ── Dock mobile : menu + compteur panier synchronisé ── */
(function () {
  const dock = document.querySelector('.dock');
  if (!dock) return;
  const boutonMenu = dock.querySelector('[data-dock-menu]');
  if (boutonMenu && typeof burger !== 'undefined' && burger) {
    boutonMenu.addEventListener('click', () => burger.click());
  }
  const compteDock = dock.querySelector('[data-dock-count]');
  const badge = document.getElementById('panier-count');
  if (compteDock && badge && 'MutationObserver' in window) {
    new MutationObserver(() => {
      compteDock.textContent = badge.textContent;
      compteDock.classList.remove('pop'); void compteDock.offsetWidth; compteDock.classList.add('pop');
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  }
})();

/* ── Roll des lettres sur la nav desktop (text-roll 21st) ── */
if (!reduceOS && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.querySelectorAll('nav.main a').forEach((lien) => {
    const texte = lien.textContent.trim();
    if (!texte || texte.length > 24) return;
    const pile = (cls) => '<span class="' + cls + '" aria-hidden="true">' +
      texte.split('').map((c, i) => '<i style="--i:' + i + '">' + (c === ' ' ? '&nbsp;' : c) + '</i>').join('') + '</span>';
    lien.setAttribute('aria-label', texte);
    lien.innerHTML = '<span class="roll-boite">' + pile('roll-a') + pile('roll-b') + '</span>';
  });
}

/* ── Menu mobile : entrée en cascade des liens ── */
/* stagger : les --i sont posés côté Liquid sur .pn-liens a */

/* ── FAQ : l'accordéon s'ouvre en douceur (hauteur animée, sémantique intacte) ── */
document.querySelectorAll('details.faq-item').forEach((d) => {
  const resume = d.querySelector('summary');
  const reponse = d.querySelector('.freponse');
  if (!resume || !reponse) return;
  resume.addEventListener('click', (e) => {
    if (reduceOS) return; /* natif instantané */
    e.preventDefault();
    if (d.open) {
      const h = reponse.offsetHeight;
      reponse.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' })
        .onfinish = () => { d.open = false; };
    } else {
      d.open = true;
      const h = reponse.offsetHeight;
      reponse.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
    }
  });
});

/* ── Collections : masquer les épuisés (mémorisé) ── */
(function () {
  const bouton = document.getElementById('filtre-dispo');
  const grille = document.querySelector('.grille-collection');
  if (!bouton || !grille) return;
  const applique = (actif) => {
    grille.classList.toggle('sans-epuises', actif);
    bouton.setAttribute('aria-pressed', String(actif));
    bouton.classList.toggle('actif', actif);
  };
  applique(localStorage.getItem('mm-dispo') === '1');
  bouton.addEventListener('click', () => {
    const actif = !grille.classList.contains('sans-epuises');
    try { localStorage.setItem('mm-dispo', actif ? '1' : '0'); } catch (e) {}
    applique(actif);
  });
})();

/* ── Zoom produit : la photo s'ouvre en grand ── */
(function () {
  const visuel = document.querySelector('.produit-fiche .galerie > img');
  if (!visuel) return;
  visuel.style.cursor = 'zoom-in';
  visuel.addEventListener('click', () => {
    const boite = document.createElement('div');
    boite.className = 'zoom-produit';
    boite.setAttribute('role', 'dialog');
    boite.setAttribute('aria-label', 'Photo en grand');
    boite.innerHTML = '<img src="' + visuel.src + '" alt="">';
    document.body.appendChild(boite);
    document.documentElement.style.overflow = 'hidden';
    const fermeZoom = () => { boite.remove(); document.documentElement.style.overflow = ''; document.removeEventListener('keydown', surEsc); };
    const surEsc = (e) => { if (e.key === 'Escape') fermeZoom(); };
    boite.addEventListener('click', fermeZoom);
    document.addEventListener('keydown', surEsc);
  });
})();

/* ── (v35 : curseur candy retiré — banni par les doctrines design, perf/a11y) ── */

/* ══════════════════════════════════════════════════════════════
   FOURNÉE 21st v14 — toasts, spotlight, vélocité, header futé,
   parallaxe souris du héros, jelly (site d'agence, on assume)
   ══════════════════════════════════════════════════════════════ */

/* ── Toasts cartoon (leçons Sonner : transitions interruptibles, pile bornée) ── */
function montreToast(titre, texte, actionTexte, actionHref) {
  let pile = document.getElementById('toasts');
  if (!pile) {
    pile = document.createElement('div');
    pile.id = 'toasts';
    pile.setAttribute('aria-live', 'polite');
    document.body.appendChild(pile);
  }
  while (pile.children.length >= 3) pile.firstElementChild.remove();
  const t = document.createElement('div');
  t.className = 'toast-mm';
  t.innerHTML = '<svg class="icon" aria-hidden="true"><use href="#i-sac"/></svg>' +
    '<div class="toast-corps"><b>' + titre + '</b>' + (texte ? '<span>' + texte + '</span>' : '') + '</div>' +
    (actionTexte ? '<a class="toast-action" href="' + actionHref + '">' + actionTexte + '</a>' : '') +
    '<button class="toast-ferme" type="button" aria-label="Fermer">&times;</button>';
  pile.appendChild(t);
  requestAnimationFrame(() => t.classList.add('la'));
  let minuteurToast = setTimeout(pars, 3800);
  function pars() {
    clearTimeout(minuteurToast);
    t.classList.remove('la');
    setTimeout(() => t.remove(), 380);
  }
  t.addEventListener('mouseenter', () => clearTimeout(minuteurToast));
  t.addEventListener('mouseleave', () => { minuteurToast = setTimeout(pars, 2000); });
  t.querySelector('.toast-ferme').addEventListener('click', pars);
}

/* ── Spotlight : le halo suit la souris dans les cartes (réf. spotlight-card) ── */
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduceOS) {
  document.querySelectorAll('.carte-produit, .carte-pack, .tuile-univers, .ua-carte, .item-panier').forEach((carte) => {
    carte.classList.add('spot');
    carte.addEventListener('pointermove', (e) => {
      const r = carte.getBoundingClientRect();
      carte.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
      carte.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
    }, { passive: true });
  });
}

/* ── Les marquees réagissent à la vitesse du scroll (skew façon velocity) ── */
if (!reduceOS && typeof gsap !== 'undefined') {
  const rails = document.querySelectorAll('.marques-rail-wrap, .tickets-defile, .avis-defile, .ruban-wrap');
  if (rails.length) {
    let yPrec = window.scrollY, skew = 0;
    gsap.ticker.add(() => {
      const y = window.scrollY;
      const cible = Math.max(-6, Math.min(6, (y - yPrec) * 0.22));
      yPrec = y;
      skew += (cible - skew) * 0.12;
      if (Math.abs(skew) > 0.05) rails.forEach((r) => { r.style.transform = 'skewX(' + skew.toFixed(2) + 'deg)'; });
    });
  }
}

/* ── Header futé : il s'efface à la descente, revient à la montée ── */
(function () {
  if (!header) return;
  let yAvant = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const menuOuvert = panneau && panneau.classList.contains('ouvert');
    if (!menuOuvert) {
      if (y > 160 && y > yAvant + 6) header.classList.add('cache');
      else if (y < yAvant - 4 || y < 160) header.classList.remove('cache');
    }
    yAvant = y;
  }, { passive: true });
})();

/* ── Parallaxe souris du héros : les packshots respirent avec le curseur ── */
if (!reduceOS && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  const heroP = document.querySelector('.hero-poster');
  if (heroP) {
    const couches = [
      { el: heroP.querySelector('.flotteur-1 img'), force: 22 },
      { el: heroP.querySelector('.flotteur-2 img'), force: 30 },
      { el: heroP.querySelector('.poster-note'), force: 8 }
    ].filter((c) => c.el);
    let mx = 0, my = 0, ax = 0, ay = 0, vif = false;
    heroP.addEventListener('pointermove', (e) => {
      const r = heroP.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - 0.5;
      my = (e.clientY - r.top) / r.height - 0.5;
      if (!vif) { vif = true; anime(); }
    }, { passive: true });
    function anime() {
      ax += (mx - ax) * 0.06; ay += (my - ay) * 0.06;
      couches.forEach((c) => {
        c.el.style.translate = (ax * c.force) + 'px ' + (ay * c.force * 0.7) + 'px';
      });
      requestAnimationFrame(anime);
    }
  }
}

/* ══════════════════════════════════════════════════════════════
   FOURNÉE 21st v15 — reveals d'images, retour-lune
   ══════════════════════════════════════════════════════════════ */

/* ── Reveal des visuels au scroll (clip-path, façon rideau) ── */
if (!reduceOS && 'IntersectionObserver' in window) {
  const cibles = document.querySelectorAll('.boutique-media, .tuile-univers:not(.fan-carte), .poster-media .cadre');
  if (cibles.length) {
    const ioReveal = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (!e.isIntersecting) return;
        ioReveal.unobserve(e.target);
        e.target.classList.add('devoile');
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    cibles.forEach((el) => { el.classList.add('revele'); ioReveal.observe(el); });
  }
}


/* ══════════════════════════════════════════════════════════════
   FOURNÉE 21st v16 — toutes les pages vivent
   ══════════════════════════════════════════════════════════════ */

/* ── FAQ : filtre instantané dans les questions ── */
(function () {
  const champ = document.getElementById('faq-cherche');
  if (!champ) return;
  const items = [...document.querySelectorAll('details.faq-item')];
  const rien = document.getElementById('faq-rien');
  champ.addEventListener('input', () => {
    const q = champ.value.trim().toLowerCase();
    let visibles = 0;
    items.forEach((d) => {
      const ok = !q || d.textContent.toLowerCase().includes(q);
      d.hidden = !ok;
      if (ok) visibles++;
    });
    if (rien) rien.hidden = visibles > 0;
  });
})();

/* ── L'heure d'Épinal, en direct dans le footer + mode nuit 22h-6h ── */
(function () {
  const fmt = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris' });
  function maj() {
    const heure = fmt.format(new Date());
    const h = parseInt(heure, 10);
    const nuit = h >= 22 || h < 6;
    /* Vendredi et samedi ferment à 4h. Le dimanche ferme à 2h — mais la nuit
       du samedi au dimanche appartient encore au samedi. */
    const jour = new Date().getDay();
    const fermeA = (jour === 5 || jour === 6 || (jour === 0 && h < 6)) ? 4 : 2;
    const ouvreA = (window.MMConfig && window.MMConfig.ouvreA) || 14;
    const ouvert = h >= ouvreA || h < fermeA;
    /* (v33 : l'horloge n'est plus affichée — on garde le mode nuit) */
    document.documentElement.classList.toggle('mode-nuit', nuit);
    const annonceTxt = document.getElementById('annonce-txt');
    if (nuit && annonceTxt && !annonceTxt.dataset.nuit) {
      annonceTxt.dataset.nuit = '1';
      annonceTxt.innerHTML = 'Il est tard, on est là — <b>livraison locale jusqu’à ' + fermeA + 'h</b>';
    }
  }
  maj();
  setInterval(maj, 30000);
})();

/* ── Fiche produit : les miniatures pilotent la grande photo ── */
(function () {
  const grande = document.querySelector('.produit-fiche .galerie > img');
  const minis = document.querySelectorAll('.produit-fiche .galerie div img');
  if (!grande || minis.length < 2) return;
  minis.forEach((mini) => {
    mini.style.cursor = 'pointer';
    mini.setAttribute('tabindex', '0');
    mini.setAttribute('role', 'button');
    const change = () => {
      if (grande.dataset.courante === mini.src) return;
      grande.dataset.courante = mini.src;
      const grandeSrc = mini.src.replace(/width=\d+/, 'width=900');
      if (animOK()) {
        grande.animate([{ opacity: 1 }, { opacity: 0.25 }], { duration: 130, easing: 'ease-out' }).onfinish = () => {
          grande.src = grandeSrc;
          grande.animate([{ opacity: 0.25, transform: 'scale(0.985)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 240, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
        };
      } else { grande.src = grandeSrc; }
      minis.forEach((m) => m.classList.toggle('mini-active', m === mini));
    };
    mini.addEventListener('click', change);
    mini.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); change(); } });
  });
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE 21st v17 — la fiche produit et la home en vedettes
   ══════════════════════════════════════════════════════════════ */

/* ── Barre d'achat flottante : apparaît quand le CTA principal sort ── */
(function () {
  const barre = document.getElementById('barre-achat');
  const cible = document.querySelector('.achat-sticky');
  if (!barre || !cible || !('IntersectionObserver' in window)) return;
  new IntersectionObserver((es) => {
    const visible = es[0].isIntersecting;
    if (!visible && es[0].boundingClientRect.top < 0) { barre.hidden = false; requestAnimationFrame(() => barre.classList.add('la')); }
    else { barre.classList.remove('la'); setTimeout(() => { if (!barre.classList.contains('la')) barre.hidden = true; }, 320); }
  }).observe(cible);
  const bouton = document.getElementById('ba-ajout');
  if (bouton) bouton.addEventListener('click', () => {
    const principal = document.querySelector('.achat-sticky .btn[type="submit"]');
    if (principal) principal.click();
    else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(bouton.dataset.variant, 10), quantity: 1 }] }) })
        .then((r) => r.ok ? fetch('/cart.js').then((c) => c.json()) : Promise.reject())
        .then((cart) => {
          const bc = document.getElementById('panier-count');
          if (bc) bc.textContent = cart.item_count;
          if (typeof montreToast === 'function') montreToast("C'est dans le sac !", '', 'Voir le panier', '/cart');
          if (typeof popCandy === 'function') popCandy(bouton);
        }).catch(() => {});
    }
  });
})();

/* ── Jauge franco sur la fiche : « plus que X € » en direct ── */
(function () {
  const jauge = document.querySelector('[data-jauge-franco]');
  if (!jauge) return;
  const seuil = parseInt(jauge.dataset.seuil, 10) || 4000;
  fetch('/cart.js').then((r) => r.json()).then((cart) => {
    if (cart.item_count === 0) return; /* panier vide : pas de pression inutile */
    const reste = seuil - cart.total_price;
    const texte = jauge.querySelector('.franco-txt');
    const barre = jauge.querySelector('.barre-seuil i');
    if (reste > 0) {
      texte.innerHTML = 'Plus que <b>€' + (reste / 100).toFixed(2).replace('.', ',') + '</b> et la livraison France est <b>offerte</b>';
    } else {
      texte.innerHTML = 'Livraison France <b>offerte</b> sur ta commande — bien joué.';
      jauge.classList.add('franco-ok');
    }
    barre.style.width = Math.min(100, Math.round(cart.total_price * 100 / seuil)) + '%';
    jauge.hidden = false;
  }).catch(() => {});
})();

/* ── Partager (Web Share, sinon copie du lien) ── */
document.querySelectorAll('[data-partage]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const donnees = { title: btn.dataset.titre || document.title, url: location.href };
    if (navigator.share) { navigator.share(donnees).catch(() => {}); return; }
    navigator.clipboard.writeText(location.href).then(() => {
      const lbl = btn.querySelector('.lbl-partage');
      if (lbl) { lbl.textContent = 'Lien copié !'; setTimeout(() => { lbl.textContent = 'Partager'; }, 1800); }
    }).catch(() => {});
  });
});

/* ── Pages légales : sommaire automatique quand c'est long ── */
(function () {
  if (!document.body.classList.contains('template-page')) return;
  const contenu = document.querySelector('.page-mm div[style*="70ch"], .page-mm .rte');
  if (!contenu) return;
  const titres = contenu.querySelectorAll('h2');
  if (titres.length < 3) return;
  const sommaire = document.createElement('nav');
  sommaire.className = 'sommaire-page';
  sommaire.setAttribute('aria-label', 'Sommaire');
  sommaire.innerHTML = '<b>Dans cette page</b>';
  const ul = document.createElement('ul');
  titres.forEach((h, i) => {
    if (!h.id) h.id = 'section-' + (i + 1);
    const li = document.createElement('li');
    li.innerHTML = '<a href="#' + h.id + '">' + h.textContent + '</a>';
    ul.appendChild(li);
  });
  sommaire.appendChild(ul);
  contenu.parentNode.insertBefore(sommaire, contenu);
})();

/* ── Le titre d'onglet fait de l'œil quand on s'absente ── */
(function () {
  const titreInitial = document.title;
  document.addEventListener('visibilitychange', () => {
    document.title = document.hidden ? 'Psst… ton snack t’attend | MIDI MINUIT' : titreInitial;
  });
})();

/* ── La grande photo produit s'incline sous la souris ── */
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  const photoFiche = document.querySelector('.produit-fiche .galerie');
  if (photoFiche) {
    photoFiche.addEventListener('pointermove', (ev) => {
      if (!animOK()) return;
      const r = photoFiche.getBoundingClientRect();
      const x = (ev.clientX - r.left) / r.width - 0.5;
      const y = (ev.clientY - r.top) / r.height - 0.5;
      photoFiche.style.transform = `perspective(900px) rotateY(${x * 5}deg) rotateX(${y * -5}deg)`;
    });
    photoFiche.addEventListener('pointerleave', () => { photoFiche.style.transform = ''; });
  }
}

/* ── Shimmer : on l'éteint dès que l'image est arrivée ── */
(function () {
  const marque = (img) => img.setAttribute('data-charge', '1');
  document.querySelectorAll('.carte-produit .visuel img, .fan-carte img').forEach((img) => {
    if (img.complete && img.naturalWidth > 0) marque(img);
    else { img.addEventListener('load', () => marque(img), { once: true }); img.addEventListener('error', () => marque(img), { once: true }); }
  });
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE v18 — code promo, description repliable
   ══════════════════════════════════════════════════════════════ */

/* ── Code promo : enregistré côté Shopify, appliqué au paiement ── */
(function () {
  const form = document.querySelector('[data-promo]');
  if (!form) return;
  const champ = document.getElementById('champ-promo');
  const note = document.getElementById('promo-note');
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const code = champ.value.trim();
    if (!code) return;
    fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' })
      .then(() => {
        note.textContent = 'Code « ' + code.toUpperCase() + ' » enregistré — il s’appliquera au paiement.';
        note.hidden = false;
        champ.value = '';
        if (typeof popCandy === 'function') popCandy(form.querySelector('button'));
      })
      .catch(() => { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart'; });
  });
})();

/* ── Description produit : repliée avec fondu, « Lire la suite » ── */
(function () {
  const desc = document.querySelector('.p-desc-fiche');
  if (!desc) return;
  (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(() => {
    if (desc.scrollHeight <= 160) return; /* courte : rien à replier */
    desc.classList.add('repliee');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lire-suite';
    btn.textContent = 'Lire la suite';
    btn.setAttribute('aria-expanded', 'false');
    desc.after(btn);
    btn.addEventListener('click', () => {
      const ouvre = desc.classList.contains('repliee');
      const depart = desc.offsetHeight;
      desc.classList.toggle('repliee');
      const arrivee = desc.offsetHeight;
      if (animOK()) {
        desc.style.overflow = 'hidden';
        desc.animate([{ height: depart + 'px' }, { height: arrivee + 'px' }], { duration: 340, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' })
          .onfinish = () => { desc.style.overflow = ''; };
      }
      btn.textContent = ouvre ? 'Replier' : 'Lire la suite';
      btn.setAttribute('aria-expanded', String(ouvre));
    });
  });
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE 21st v19 — vu récemment, préchargement, petits plaisirs
   ══════════════════════════════════════════════════════════════ */

/* ── « Tu regardais ça » : historique local, zéro serveur ── */
(function () {
  const CLE = 'mm-vus';
  const lis = () => { try { return JSON.parse(localStorage.getItem(CLE) || '[]'); } catch (e) { return []; } };
  /* enregistrement (fiche produit) */
  const donnees = document.getElementById('produit-vu');
  if (donnees) {
    try {
      const p = JSON.parse(donnees.textContent);
      const liste = [p].concat(lis().filter((x) => x.handle !== p.handle)).slice(0, 8);
      localStorage.setItem(CLE, JSON.stringify(liste));
    } catch (e) {}
  }
  /* rendu (fiche + panier vide) */
  document.querySelectorAll('[data-vus]').forEach((bloc) => {
    const exclure = bloc.dataset.exclure;
    const liste = lis().filter((x) => x.handle !== exclure).slice(0, 6);
    if (liste.length < 2) return;
    const rail = bloc.querySelector('.vus-rail');
    rail.innerHTML = liste.map((p) =>
      '<a class="vu-carte" href="' + p.url + '">' +
      (p.img ? '<img src="' + p.img + '" alt="" width="90" height="90" loading="lazy">' : '') +
      '<span class="vu-nom">' + p.titre + '</span><b class="chiffre">' + p.prix + '</b></a>'
    ).join('');
    bloc.hidden = false;
  });
})();

/* ── Préchargement au survol : la page suivante est déjà là ── */
(function () {
  if (navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''))) return;
  const deja = new Set();
  const precharge = (href) => {
    if (deja.has(href) || deja.size > 30) return;
    deja.add(href);
    const l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    document.head.appendChild(l);
  };
  document.addEventListener('pointerenter', (e) => {
    if (!e.target || !e.target.closest) return;
    const a = e.target.closest('a[href^="/products/"], a[href^="/collections/"], a[href^="/pages/"]');
    if (a) precharge(a.getAttribute('href').split('#')[0]);
  }, { capture: true, passive: true });
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE v21 — toasts franco, exit-intent, placeholder vivant,
   horloge badgée
   ══════════════════════════════════════════════════════════════ */

/* ── Placeholder machine à écrire (palette + page recherche) ── */
(function () {
  const champs = [document.getElementById('palette-input'), document.querySelector('[data-placeholder-anime]')].filter(Boolean);
  if (!champs.length || reduceOS) return;
  const envies = ['matcha ?', 'spicy ?', 'soda japonais ?', 'fraise ?', 'monster ?', 'chips introuvables ?'];
  let iEnvie = 0, iCar = 0, sens = 1;
  setInterval(() => {
    champs.forEach((c) => { if (document.activeElement === c || c.value) return; c.placeholder = 'Une envie ? ' + envies[iEnvie].slice(0, iCar); });
    iCar += sens;
    if (iCar > envies[iEnvie].length + 6) { sens = -1; iCar = envies[iEnvie].length; }
    if (iCar < 0) { sens = 1; iCar = 0; iEnvie = (iEnvie + 1) % envies.length; }
  }, 90);
})();

/* ── Exit-intent (desktop, 1×/session) : le -10 % avant de partir.
      Ne s'arme QUE si une inscription newsletter existe sur le site —
      sinon la promesse pointerait dans le vide. ── */
(function () {
  if (!document.querySelector('#newsletter, .news-form')) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  try { if (sessionStorage.getItem('mm-sortie')) return; } catch (e) { return; }
  let arme = false;
  setTimeout(() => { arme = true; }, 12000);
  document.addEventListener('mouseout', function surSortie(e) {
    if (!arme || e.relatedTarget || e.clientY > 24) return;
    document.removeEventListener('mouseout', surSortie);
    try { sessionStorage.setItem('mm-sortie', '1'); } catch (err) {}
    const boite = document.createElement('div');
    boite.className = 'sortie-modale';
    boite.setAttribute('role', 'dialog');
    boite.setAttribute('aria-label', 'Avant de partir');
    boite.innerHTML = '<div class="sortie-carte">' +
      '<button class="toast-ferme" type="button" aria-label="Fermer">&times;</button>' +
      '<p class="sortie-accent">Minute !</p>' +
      '<b>−10 % sur ta première commande</b>' +
      '<p>Inscris-toi à la newsletter avant de filer — le code arrive direct dans ta boîte.</p>' +
      '<a class="btn btn-magenta" href="/#newsletter">Je prends le code</a></div>';
    document.body.appendChild(boite);
    const ferme = () => boite.remove();
    boite.addEventListener('click', (ev) => { if (ev.target === boite || ev.target.closest('.toast-ferme')) ferme(); });
    boite.querySelector('a').addEventListener('click', ferme);
    document.addEventListener('keydown', function surEscS(ev) { if (ev.key === 'Escape') { ferme(); document.removeEventListener('keydown', surEscS); } });
  });
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE 21st v22 — textes & animations
   ══════════════════════════════════════════════════════════════ */

/* ── Magnétisme discret sur tous les CTA cartoon (desktop fin) ── */
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.querySelectorAll('.btn-cartoon, .btn-magenta, .btn-blanc-cartoon').forEach((b) => {
    if (b.id === 'cta-magnetique') return; /* déjà servi, plus fort */
    b.addEventListener('pointermove', (ev) => {
      if (!animOK()) return;
      const r = b.getBoundingClientRect();
      const x = (ev.clientX - r.left) / r.width - 0.5;
      const y = (ev.clientY - r.top) / r.height - 0.5;
      b.style.setProperty('--mgx', (x * 4).toFixed(1) + 'px');
      b.style.setProperty('--mgy', (y * 3).toFixed(1) + 'px');
    });
    b.addEventListener('pointerleave', () => { b.style.setProperty('--mgx', '0px'); b.style.setProperty('--mgy', '0px'); });
  });
}

/* ── Le prix de la fiche morph au changement de variante ── */
(function () {
  const sel = document.querySelector('.produit-fiche select[name="id"]');
  const prix = document.querySelector('.p-prix-fiche');
  if (!sel || !prix) return;
  sel.addEventListener('change', () => {
    if (!animOK() || !prix.animate) return;
    prix.animate(
      [{ opacity: 0.2, transform: 'translateY(-7px) scale(0.96)', filter: 'blur(3px)' },
       { opacity: 1, transform: 'none', filter: 'none' }],
      { duration: 320, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
    );
  });
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE 21st v23 — signature, histoire, navigation
   ══════════════════════════════════════════════════════════════ */

/* ── Scramble du mot rotatif du héros (adapté Scramble Hover 21st) ── */
function scrambleMot(el) {
  if (!animOK() || el.dataset.brasse === '1') return;
  const fin = el.dataset.txtOriginal || (el.dataset.txtOriginal = el.textContent);
  const pool = 'abcdefghjkmnpqrstuvwxyz';
  let etape = 0;
  const total = 9;
  el.dataset.brasse = '1';
  (function tour() {
    etape += 1;
    if (document.visibilityState !== 'visible') { el.textContent = fin; delete el.dataset.brasse; return; }
    const fige = Math.floor((etape / total) * fin.length);
    el.textContent = fin.split('').map((c, i) => {
      if (c === ' ' || i < fige) return c;
      return pool[Math.floor((i * 7 + etape * 13) % pool.length)];
    }).join('');
    if (etape < total) { setTimeout(tour, 42); }
    else { el.textContent = fin; delete el.dataset.brasse; }
  })();
}

/* ── Signature géante du footer : se remplit de slush à l'arrivée ── */
(function () {
  const mg = document.querySelector('.marque-geante');
  if (!mg || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((ens) => {
    ens.forEach((en) => { if (en.isIntersecting) { mg.classList.add('plein'); io.disconnect(); } });
  }, { threshold: 0.4 });
  io.observe(mg);
})();

/* ── Barre de chargement de navigation (sensation SPA sur un site MPA) ── */
(function () {
  if (reduceOS) return;
  const barre = document.createElement('div');
  barre.id = 'chargeur-nav';
  document.body.appendChild(barre);
  document.addEventListener('click', (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    const a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
    if (a.origin && a.origin !== location.origin) return;
    if (a.pathname === location.pathname && a.search === location.search && a.hash) return;
    barre.classList.add('roule');
  }, { capture: true });
  window.addEventListener('pagehide', () => barre.classList.add('fini'));
  window.addEventListener('pageshow', (e) => { if (e.persisted) barre.classList.remove('roule', 'fini'); });
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE v32 — footer cinématique (adapté motion-footer 21st)
   ══════════════════════════════════════════════════════════════ */

/* ── Pills magnétiques du footer (GSAP, souris fine uniquement) ── */
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && typeof gsap !== 'undefined') {
  document.querySelectorAll('[data-magnet]').forEach((el) => {
    el.addEventListener('mousemove', (e) => {
      if (!animOK()) return;
      const r = el.getBoundingClientRect();
      const x = e.clientX - r.left - r.width / 2;
      const y = e.clientY - r.top - r.height / 2;
      gsap.to(el, { x: x * 0.4, y: y * 0.4, rotationX: -y * 0.15, rotationY: x * 0.15, scale: 1.05, ease: 'power2.out', duration: 0.4 });
    });
    el.addEventListener('mouseleave', () => {
      gsap.to(el, { x: 0, y: 0, rotationX: 0, rotationY: 0, scale: 1, ease: 'elastic.out(1, 0.3)', duration: 1.2 });
    });
  });
}

/* ── Révélations du footer au scroll (texte géant + contenu) ── */
(function () {
  const rideau = document.querySelector('.rideau-footer');
  if (!rideau || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || reduceOS) return;
  const geant = rideau.querySelector('.fp-geant');
  const centre = rideau.querySelector('.fp-centre');
  if (geant) {
    gsap.fromTo(geant, { yPercent: 18, scale: 0.84, opacity: 0 }, {
      yPercent: 0, scale: 1, opacity: 1, ease: 'power1.out',
      scrollTrigger: { trigger: rideau, start: 'top 85%', end: 'bottom bottom', scrub: 1 }
    });
  }
  if (centre) {
    gsap.fromTo(centre.children, { y: 46, opacity: 0 }, {
      y: 0, opacity: 1, stagger: 0.12, ease: 'power3.out',
      scrollTrigger: { trigger: rideau, start: 'top 55%', end: 'bottom bottom', scrub: 1 }
    });
  }
})();

/* ── Retour en haut, tout en douceur ── */
document.querySelectorAll('.fp-top').forEach((b) => {
  b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: animOK() ? 'smooth' : 'auto' }));
});

/* ── La nuit tombe d'un coup sur les formules : les néons s'allument ── */
(function () {
  const panneau = document.querySelector('#packs .panneau-nuit, .packs .panneau-nuit, .panneau-nuit');
  if (!panneau || reduceOS || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((es) => {
    es.forEach((en) => { if (en.isIntersecting) { panneau.classList.add('nuit-tombee'); io.disconnect(); } });
  }, { threshold: 0.3 });
  io.observe(panneau);
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE v26 — étincelles multiples (adapté Sparkles Text 21st)
   ══════════════════════════════════════════════════════════════ */
(function () {
  if (reduceOS) return;
  const CHEMIN = 'M9.8 0.8C10 0.2 10.9 0.2 11.2 0.8L11.9 2.7C12.4 4.2 12.4 6.4 13.5 7.5C14.6 8.6 16.8 8.6 18.3 9.1L20.2 9.8C20.8 10 20.8 10.9 20.2 11.2L18.3 11.9C16.8 12.4 14.6 12.4 13.5 13.5C12.4 14.6 12.4 16.8 11.9 18.3L11.2 20.2C10.9 20.8 10 20.8 9.8 20.2L9.1 18.3C8.6 16.8 8.6 14.6 7.5 13.5C6.4 12.4 4.2 12.4 2.7 11.9L0.8 11.2C0.2 10.9 0.2 10 0.8 9.8L2.7 9.1C4.2 8.6 6.4 8.6 7.5 7.5C8.6 6.4 8.6 4.2 9.1 2.7L9.8 0.8Z';
  const COULEURS = ['#E878E0', '#38E8F0', '#fff'];
  document.querySelectorAll('[data-sparkles]').forEach((hote) => {
    hote.classList.add('a-etincelles');
    const n = parseInt(hote.dataset.sparkles, 10) || 6;
    for (let i = 0; i < n; i++) {
      const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('viewBox', '0 0 21 21');
      s.setAttribute('class', 'etincelle');
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<path d="' + CHEMIN + '" fill="' + COULEURS[i % COULEURS.length] + '"/>';
      const place = () => {
        s.style.left = (Math.random() * 104 - 2) + '%';
        s.style.top = (Math.random() * 104 - 6) + '%';
        s.style.setProperty('--se', (Math.random() * 0.7 + 0.4).toFixed(2));
      };
      place();
      s.style.animationDelay = (Math.random() * 2.2).toFixed(2) + 's';
      s.addEventListener('animationiteration', place);
      hote.appendChild(s);
    }
  });
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE v25 — cartes 3D, timeline colis
   ══════════════════════════════════════════════════════════════ */

/* ── Cartes promesses : tilt 3D qui suit la souris + reflet orienté
      (adapté animated-3d-card 21st, en vanilla) ── */
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.querySelectorAll('[data-tilt3d]').forEach((carte) => {
    carte.addEventListener('pointermove', (ev) => {
      if (!animOK()) return;
      const r = carte.getBoundingClientRect();
      if (!r.width) return;
      const px = (ev.clientX - r.left) / r.width - 0.5;
      const py = (ev.clientY - r.top) / r.height - 0.5;
      carte.style.setProperty('--ry', (px * 14).toFixed(1) + 'deg');
      carte.style.setProperty('--rx', (py * -14).toFixed(1) + 'deg');
      carte.style.setProperty('--ang', (135 + px * 40).toFixed(0) + 'deg');
      carte.classList.add('penche');
    });
    carte.addEventListener('pointerleave', () => {
      carte.style.setProperty('--ry', '0deg');
      carte.style.setProperty('--rx', '0deg');
      carte.classList.remove('penche');
    });
  });
}

/* ── Timeline colis : les étapes s'allument à l'arrivée à l'écran ── */
(function () {
  const cc = document.querySelector('[data-chrono-colis]');
  if (!cc) return;
  if (!('IntersectionObserver' in window) || reduceOS) { cc.classList.add('joue'); return; }
  const io = new IntersectionObserver((es) => {
    es.forEach((en) => { if (en.isIntersecting) { cc.classList.add('joue'); io.disconnect(); } });
  }, { threshold: 0.4 });
  io.observe(cc);
})();

/* ══════════════════════════════════════════════════════════════
   FOURNÉE 21st v24 — pack typo & effets de texte
   ══════════════════════════════════════════════════════════════ */

/* ── H1 internes & 404 : chaque lettre tombe du haut (adapté Top Down Letters 21st) ── */
function decoupeEnLettres(h) {
  if (h.dataset.lettres === '1' || h.textContent.length > 60) return;
  h.dataset.lettres = '1';
  h.setAttribute('aria-label', h.textContent.trim());
  const morceaux = [];
  let li = 0;
  /* On DÉPLACE les éléments (jamais de clone) : les moteurs qui ont déjà
     une référence dessus (cadre pointer, souligné IO) continuent de vivre. */
  Array.from(h.childNodes).forEach((n) => {
    if (n.nodeType === Node.TEXT_NODE) {
      n.textContent.split('').forEach((c) => {
        if (/\s/.test(c)) { morceaux.push(document.createTextNode(c)); return; }
        const i = document.createElement('i');
        i.className = 'lc'; i.textContent = c;
        i.setAttribute('aria-hidden', 'true');
        i.style.setProperty('--lc', li++);
        morceaux.push(i);
      });
    } else {
      /* les accents CatchLAND restent entiers : la cursive ne se découpe pas */
      const bloc = document.createElement('span');
      bloc.className = 'lc lc-bloc';
      bloc.style.setProperty('--lc', li++);
      bloc.appendChild(n);
      morceaux.push(bloc);
    }
  });
  h.textContent = '';
  morceaux.forEach((m) => h.appendChild(m));
}
if (!reduceOS) {
  document.querySelectorAll('.page-mm > h1, .page-mm .sec-head h1, .legale-tete h1, .chiffre-404').forEach(decoupeEnLettres);
}

/* ── Les liens XXL du menu se brouillent puis se posent (adapté Hyper Text 21st) ── */
(function () {
  const pn = document.querySelector('.panneau-nav');
  if (!pn || !('MutationObserver' in window)) return;
  let etaitOuvert = false;
  new MutationObserver(() => {
    const ouvert = pn.classList.contains('ouvert');
    if (ouvert && !etaitOuvert) {
      pn.querySelectorAll('.pn-mot').forEach((mot, i) => {
        setTimeout(() => scrambleMot(mot), 120 + i * 70);
      });
    }
    etaitOuvert = ouvert;
  }).observe(pn, { attributes: true, attributeFilter: ['class'] });
})();

/* ── Le compteur du dock rebondit quand le panier change ── */
(function () {
  const cd = document.querySelector('[data-dock-count]');
  if (!cd || !('MutationObserver' in window)) return;
  new MutationObserver(() => {
    if (!animOK()) return;
    cd.classList.remove('pop');
    void cd.offsetWidth;
    cd.classList.add('pop');
  }).observe(cd, { childList: true, characterData: true, subtree: true });
})();


/* ══════════════════════════════════════════════════════════════
   FOURNÉE v44 — le trait qui souligne, le cercle qui entoure
   ══════════════════════════════════════════════════════════════ */

/* ── Surlignages : le marqueur passe sur les infos quand elles arrivent ──
   IO dédié et PERSISTANT (celui des .reveal retire sa classe après 560 ms). */
(function () {
  const cibles = document.querySelectorAll('.surligne');
  if (!cibles.length) return;
  if (!('IntersectionObserver' in window)) {
    cibles.forEach((c) => c.classList.add('surligne-ok'));
    return;
  }
  const io = new IntersectionObserver((entrees) => {
    entrees.forEach((e) => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      e.target.classList.add('surligne-ok');
    });
  }, { rootMargin: '0px 0px -12% 0px' });
  cibles.forEach((c) => io.observe(c));
})();

/* ── Entourage : un cercle tracé à la main autour du mot d'accent ──
   Le tracé suit la boîte réelle du mot et se redessine si elle change. */
(function () {
  const hotes = document.querySelectorAll('[data-entoure]');
  if (!hotes.length) return;
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  hotes.forEach((hote) => {
    const mot = hote.querySelector('.accent-catch') || hote;
    if (!mot) return;
    hote.style.position = hote.style.position || 'relative';

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'entour-svg');
    svg.setAttribute('viewBox', '0 0 100 100');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    /* Ovale ouvert, deux passages légèrement décalés : le geste de la main. */
    const trace = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    /* Un seul tour, largement autour du mot : le trait ne barre jamais le texte. */
    trace.setAttribute('d',
      'M 88 22 C 99 42, 92 78, 50 84 C 12 88, 1 64, 3 42 C 5 20, 26 10, 54 9 ' +
      'C 78 8, 93 16, 96 30');
    svg.appendChild(trace);
    hote.appendChild(svg);

    const place = () => {
      const rh = hote.getBoundingClientRect();
      const rm = mot.getBoundingClientRect();
      if (!rm.width || !rh.width) return;
      const mx = rm.width * 0.16 + 10, my = rm.height * 0.3 + 6;
      svg.style.left = (rm.left - rh.left - mx) + 'px';
      svg.style.top = (rm.top - rh.top - my) + 'px';
      svg.style.width = (rm.width + mx * 2) + 'px';
      svg.style.height = (rm.height + my * 2) + 'px';
    };
    place();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(hote);

    const L = trace.getTotalLength();
    if (reduit) { trace.style.strokeDasharray = 'none'; return; }
    trace.style.strokeDasharray = L;
    trace.style.strokeDashoffset = L;
    if (!('IntersectionObserver' in window)) { trace.style.strokeDashoffset = 0; return; }
    const io = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        place();
        trace.style.strokeDashoffset = '0';
      });
    }, { rootMargin: '0px 0px -14% 0px' });
    io.observe(hote);
  });
})();


/* ══════════════════════════════════════════════════════════════
   FOURNÉE v45 — la chaîne du froid ne prend pas le colis
   ══════════════════════════════════════════════════════════════ */

/* Les glaces ne partent qu'en livraison locale : l'ajout au panier reste
   fermé tant que le client n'a pas prouvé qu'il est dans la zone. */
(function () {
  const gate = document.querySelector('[data-froid-gate]');
  const achat = document.querySelector('[data-froid-achat]');
  if (!gate || !achat) return;

  const CLE = 'mm-zone-locale';
  const RAYON = (window.MMConfig && window.MMConfig.zoneKm) || 20;
  const BOUT = { lat: 48.1747, lon: 6.4491 };
  const bouton = achat.querySelector('button[type="submit"]');
  const champ = gate.querySelector('[data-froid-champ]');
  const valider = gate.querySelector('[data-froid-valider]');
  const msg = gate.querySelector('[data-froid-msg]');
  if (!champ || !valider) return;

  const lu = () => { try { return localStorage.getItem(CLE); } catch (e) { return null; } };

  function ouvre(nomLieu) {
    gate.hidden = true;
    if (bouton) { bouton.disabled = false; bouton.classList.remove('btn-bloque'); }
    if (nomLieu) {
      const ok = document.createElement('p');
      ok.className = 'froid-ok';
      ok.innerHTML = '<b>' + nomLieu + '</b> : on te livre en scooter, la glace arrive dure.';
      gate.parentNode.insertBefore(ok, gate);
    }
  }
  function ferme() {
    gate.hidden = false;
    if (bouton) { bouton.disabled = true; bouton.classList.add('btn-bloque'); }
  }

  if (lu() === '1') ouvre(null); else ferme();

  function distanceKm(lat, lon) {
    const R = 6371, rad = Math.PI / 180;
    const dLat = (lat - BOUT.lat) * rad, dLon = (lon - BOUT.lon) * rad;
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(BOUT.lat * rad) * Math.cos(lat * rad) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  async function verifie() {
    const q = champ.value.trim();
    if (q.length < 2) { champ.focus(); return; }
    msg.hidden = false;
    msg.className = 'fg-msg';
    msg.textContent = 'On regarde la carte…';
    let geo = null;
    try {
      const r = await fetch('https://api-adresse.data.gouv.fr/search/?limit=1&q=' + encodeURIComponent(q));
      if (r.ok) {
        const js = await r.json();
        const f = js.features && js.features[0];
        if (f) geo = { lat: f.geometry.coordinates[1], lon: f.geometry.coordinates[0], nom: f.properties.city || f.properties.label };
      }
    } catch (err) { geo = null; }

    if (!geo) {
      msg.className = 'fg-msg fg-non';
      msg.textContent = "On n'a pas trouvé ce coin. Essaie ta ville ou ton code postal à 5 chiffres.";
      return;
    }
    const km = Math.round(distanceKm(geo.lat, geo.lon));
    if (km <= RAYON) {
      try { localStorage.setItem(CLE, '1'); } catch (er) {}
      document.documentElement.classList.add('zone-locale');
      msg.hidden = true;
      ouvre(geo.nom);
    } else {
      try { localStorage.setItem(CLE, '0'); } catch (er) {}
      msg.className = 'fg-msg fg-non';
      msg.innerHTML = '<b>' + geo.nom + '</b> est à ≈ ' + km + ' km : trop loin pour le scooter, et on refuse d\'expédier une glace qui arriverait fondue. Le reste de la boutique part en colis sans souci.';
    }
  }
  valider.addEventListener('click', verifie);
  champ.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); verifie(); } });
})();


/* ══════════════════════════════════════════════════════════════
   FOURNÉE v46 — Accordéon des univers
   Une carte ouverte à la fois ; les autres reculent d'un cran par
   rang d'éloignement (--d). Premier appui = ouvrir, second = entrer.
   ══════════════════════════════════════════════════════════════ */
(function () {
  const piles = document.querySelectorAll('[data-accordeon]');
  if (!piles.length) return;
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const survolFin = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  piles.forEach((pile) => {
    const cartes = [...pile.querySelectorAll('.ua-carte')];
    if (cartes.length < 2) { cartes.forEach((c) => c.classList.add('actif')); return; }
    let actif = 0, pauseJusqua = 0, actifDepuis = 0, minuteurAuto = null;

    /* Dès que la pile approche de l'écran, on réveille toutes ses images : une
       carte repliée est trop basse pour déclencher le chargement différé toute
       seule, et son image n'arrivait qu'au moment de l'ouverture — d'où le
       blanc d'une seconde sur la carte qu'on venait de toucher. */
    const reveille = () => pile.querySelectorAll('img[loading="lazy"]').forEach((im) => {
      im.loading = 'eager';
    });
    /* Sans attendre l'entrée à l'écran : l'observateur ne se déclenchait pas de
       façon fiable et les cartes du bas restaient sans image. On laisse passer
       le premier rendu, puis on charge tout — l'utilisateur n'a pas encore eu
       le temps de descendre jusqu'ici. */
    if (document.readyState === 'complete') reveille();
    else window.addEventListener('load', reveille, { once: true });

    function pose(i) {
      actif = (i + cartes.length) % cartes.length;
      actifDepuis = Date.now();
      cartes.forEach((c, j) => {
        c.classList.toggle('actif', j === actif);
        c.style.setProperty('--d', Math.min(Math.abs(j - actif), 3));
      });
    }
    pose(0);

    const pause = () => { pauseJusqua = Date.now() + 9000; };

    cartes.forEach((carte, i) => {
      carte.addEventListener('click', (e) => {
        pause();
        /* Une carte repliée s'ouvre d'abord : on n'entre dans la collection
           qu'au geste suivant (sinon un doigt qui vise mal change de page).
           Le délai couvre le cas où la pile venait de tourner toute seule : on
           partait alors sur une collection que personne n'avait visée. */
        if (i !== actif || Date.now() - actifDepuis < 700) { e.preventDefault(); pose(i); }
      });
      carte.addEventListener('focus', () => { pause(); if (i !== actif) pose(i); });
      if (survolFin) {
        carte.addEventListener('mouseenter', () => { pause(); pile.setAttribute('data-focus', ''); pose(i); });
      }
    });
    if (survolFin) pile.addEventListener('mouseleave', () => pile.removeAttribute('data-focus'));

    /* ── Les cartes se déplient au fil du doigt ──
       On ne capte pas le geste : on lit la position de la pile dans l'écran
       pendant que la page défile. Le doigt fait donc défiler normalement, et
       les cartes s'ouvrent l'une après l'autre au passage. Capter le geste
       revenait à se battre avec le défilement natif (touch-action se fige au
       pointerdown, impossible d'arbitrer ensuite) ; là, aucun conflit possible.

       L'index se calcule sur la hauteur TOTALE de la pile, qui ne change pas
       quand une carte s'ouvre — sinon l'ouverture déplacerait la carte suivante
       sous la ligne de lecture et la pile s'emballerait en cascade. */
    if (!reduit) {
      let planifie = false, pauseGlisse = 0;
      const suitLeDoigt = () => {
        planifie = false;
        if (Date.now() < pauseGlisse) return;
        const r = pile.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        const ligne = window.innerHeight * 0.42;
        const avance = (ligne - r.top) / r.height;
        const cible = Math.max(0, Math.min(cartes.length - 1, Math.round(avance * (cartes.length - 1))));
        if (cible === actif) return;
        clearInterval(minuteurAuto);  /* le défilement du doigt prend le relais */
        pose(cible);
      };
      window.addEventListener('scroll', () => {
        if (planifie) return;
        planifie = true;
        requestAnimationFrame(suitLeDoigt);
      }, { passive: true });
      /* Après un appui volontaire, on laisse la carte choisie tranquille un
         instant plutôt que de la remplacer au premier pixel de défilement. */
      pile.addEventListener('click', () => { pauseGlisse = Date.now() + 1200; }, { passive: true });
    }

    /* Elle vit toute seule tant que personne n'y a touché : en tactile, rien
       n'indique que les cartes s'ouvrent. Au premier geste de l'utilisateur,
       elle s'arrête pour de bon — une pile qui bouge encore pendant qu'on la
       lit passe pour un bug. */
    if (!reduit) {
      let enVue = true;
      if ('IntersectionObserver' in window) {
        enVue = false;
        new IntersectionObserver((es) => { enVue = es[0].isIntersecting; }, { threshold: 0.35 }).observe(pile);
      }
      minuteurAuto = setInterval(() => {
        if (!enVue || document.visibilityState !== 'visible' || Date.now() < pauseJusqua) return;
        pose(actif + 1);
      }, 5200);
      ['pointerdown', 'keydown'].forEach((ev) => {
        pile.addEventListener(ev, () => { clearInterval(minuteurAuto); }, { once: true, passive: true });
      });
    }
  });
})();


/* ── Vignettes de poster des <video> : Shopify les rend sans alt ── */
document.querySelectorAll('video > img:not([alt])').forEach((img) => {
  img.setAttribute('alt', ''); /* poster décoratif : lecteurs d'écran passent leur chemin */
});


/* ══════════════════════════════════════════════════════════════
   FOURNÉE v48 — menu en tiroirs + statut d'ouverture
   ══════════════════════════════════════════════════════════════ */

/* Un seul tiroir ouvert à la fois : le menu reste court et lisible. */
(function () {
  const tiroirs = [...document.querySelectorAll('[data-tiroir]')];
  if (!tiroirs.length) return;
  tiroirs.forEach((t) => {
    const bouton = t.querySelector('.pn-entree');
    if (!bouton) return;
    bouton.addEventListener('click', () => {
      const ouvert = t.hasAttribute('data-ouvert');
      tiroirs.forEach((autre) => {
        autre.removeAttribute('data-ouvert');
        const b = autre.querySelector('.pn-entree');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!ouvert) {
        t.setAttribute('data-ouvert', '');
        bouton.setAttribute('aria-expanded', 'true');
      }
    });
  });
  /* Le premier tiroir s'ouvre à l'arrivée : on montre tout de suite les rayons. */
  const panneau = document.getElementById('panneau-nav');
  if (panneau) {
    new MutationObserver(() => {
      if (panneau.classList.contains('ouvert') && !document.querySelector('[data-tiroir][data-ouvert]')) {
        const premier = tiroirs[0];
        if (premier) {
          premier.setAttribute('data-ouvert', '');
          const b = premier.querySelector('.pn-entree');
          if (b) b.setAttribute('aria-expanded', 'true');
        }
      }
    }).observe(panneau, { attributes: true, attributeFilter: ['class'] });
  }
})();

/* Ouvert / fermé en direct dans le menu */
(function () {
  const chip = document.querySelector('[data-statut-boutique]');
  if (!chip) return;
  const detail = chip.querySelector('[data-statut-detail]');
  const fort = chip.querySelector('b');
  function maj() {
    const now = new Date();
    const h = parseInt(new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', timeZone: 'Europe/Paris' }).format(now), 10);
    const ouvreA = (window.MMConfig && window.MMConfig.ouvreA) || 14;
    const j = now.getDay();
    const fermeA = (j === 5 || j === 6 || (j === 0 && h < 6)) ? 4 : 2;
    const ouvert = h >= ouvreA || h < fermeA;
    chip.hidden = false;
    chip.classList.toggle('ferme', !ouvert);
    fort.textContent = ouvert ? 'Ouvert' : 'Fermé';
    if (detail) detail.textContent = ouvert ? ' · jusqu’à ' + fermeA + 'h' : ' · ouvre à ' + ouvreA + 'h';
  }
  maj();
  setInterval(maj, 60000);
})();


/* ══════════════════════════════════════════════════════════════
   Vidéos : lecture automatique forcée, pour tout le monde
   (y compris « réduire les animations » — choix assumé du client ;
   on relance aussi après un retour d'onglet, iOS coupant la lecture)
   ══════════════════════════════════════════════════════════════ */
(function () {
  const videos = [...document.querySelectorAll('#video-hero, #video-boutique, .clip-video video')];
  if (!videos.length) return;
  const lance = (v) => {
    v.muted = true; v.defaultMuted = true;
    v.setAttribute('playsinline', '');
    const p = v.play();
    if (p && p.catch) p.catch(() => {
      /* Si le navigateur refuse encore, on réessaie au premier geste du visiteur. */
      const relance = () => { v.play().catch(() => {}); document.removeEventListener('touchstart', relance); document.removeEventListener('click', relance); };
      document.addEventListener('touchstart', relance, { once: true, passive: true });
      document.addEventListener('click', relance, { once: true });
    });
  };
  videos.forEach(lance);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') videos.forEach(lance);
  });
})();
